export const translations = {
    ru: {
        common: {
            unknownError: 'Неизвестная ошибка'
        },
        actions: {
            button: 'Вызов персонала',
            popupTitle: 'Вызов персонала',
            popupSubmitButton: 'Отправить',
            popupCloseButton: 'Закрыть',
            notifSuccess: 'Запрос отправлен',
            notifFailed: 'Ошибка. Попробуйте ещё раз',
            notifError: 'Возникла ошибка',
        },
        nav: {
            categories: 'Разделы меню',
            favorite: 'Избранное',
            search: 'Поиск',
            allergens: 'Аллергены',
        },
        buttons: {
            addToCart: 'Добавить в корзину'
        },
        search: {
            placeholder: "Поиск...",
            nothingFound: "Ничего не найдено"
        },
        order: {
            title: "Оформление заказа",
            success: {
                title: "Готово",
                message: "Заказ успешно оформлен. Мы перезвоним вам в ближайшее время",
                orderNumber: "Номер вашего заказа"
            },
            error: {
                title: "Ошибка",
                placement: "Ошибка размещения заказа"
            },
            buttons: {
                return: 'Вернуться в меню',
                retry: 'Повторить попытку',
                save: 'Сохранить меню на телефон'
            }
        },
        cart: {
            all: "Все",
            title: "Моя корзина",
            empty: "В заказе нет позиций",
            widget: "В корзине",
            itemsCount: "блюд(а)",
            openMenu: "Открыть меню",
            unnamed: "Без названия",
            notInCart: "ещё не добавлен в корзину",
            askWaiter: "Для заказа обратитесь к официанту",
            buttons: {
                retry: "Повторить попытку",
                returnToMenu: "Вернуться в меню",
                saveMenu: "Сохранить меню на телефон"
            }
        },
        filters: {
            allergens: 'Аллергены'
        },
        blocks: {
            recommendations: {
                title: "Рекомендуем",
                empty: "Нет рекомендаций"
            },
            favorites: {
                title: "Ваши любимые блюда",
                empty: "Нет избранных блюд"
            },
            total: {
                sum: "Сумма заказа",
                delivery: "Доставка",
                deliveryCost: "Стоимость доставки",
                total: "Итого"
            }
        },
        footer: {
            address: "Адрес",
            contacts: "Контакты",
            map: "Карта",
            privacyPolicy: "Политика конфиденциальности",
            termsOfUse: "Пользовательское соглашение"
        },
        cartOrder: {
            placeOrder: "Оформить заказ",
            closed: "Ресторан закрыт",
            minOrder: "Минимальный заказ",
            minOrderMessage: "Сумма вашего заказа ниже минимальной. Для оформления заказа вам необходимо добавить в корзину товары на сумму не менее",
            deliveryClosedMessage: "К сожалению сейчас служба доставки не работает, мы примем ваш заказ и обработаем его сразу же как только она откроется.",
            openInMinutes: "Доставка откроется через",
            minutes: "мин.",
            openAt: "Доставка работает с"
        },
        docs: {
            privacyPolicy: 'Политика конфиденциальности',
            accept: 'Я даю согласие на обработку моих персональных данных в соответствии с Политикой конфиденциальности и применимым законодательством о защите данных.'
        },
        legal: {
            title: 'Правовая информация'
        },
        dmLabel: {
            text: "Это меню сделано на платформе",
        },
        nutrition: {
            title: "Пищевая ценность",
            weight: "Вес порции",
            perServing: "на порцию",
            addToFavorites: "В избранное",
            inFavorites: "В избранном",
            calories: 'ккал',
            proteins: 'белки',
            fats: 'жиры',
            carbs: 'углеводы',
            gram: 'г'
        },
        allergens: {
            contains: 'Содержит',
            Cereals: 'Злаки',
            Avocado: 'Авокадо',
            Peanuts: 'Арахис',
            gluten: 'Глютен',
            Mustard: 'Горчица',
            "Sulphur dioxide": 'Диоксид серы',
            Sesame: 'Кунжут',
            Lupin: 'Люпин',
            Molluscs: 'Моллюски',
            Milk: 'Молоко',
            Nuts: 'Орехи',
            Crustaceans: 'Ракообразные',
            Fish: 'Рыба',
            Celery: 'Сельдерей',
            Soya: 'Соя',
            Eggs: 'Яйца'
        },
        addToCart: {
            add: "Добавить",
            added: "Добавлено"
        },
        details: {
            description: "Описание",
            ingredients: "Состав",
            weight: "Вес",
            close: "Закрыть"
        },
        price: {
            from: "от"
        },
        orderScreen: {
            title: "Оформление заказа",
            buttons: {
                placeOrder: 'Оформить заказ'
            },
            deliveryType: {
                label: "Как вы хотите получить заказ?",
                onsite: "В заведении",
                delivery: "Доставить по адресу",
                pickup: "Самовывоз"
            },
            fields: {
                deliveryRegion: "Район доставки",
                pickupPoint: "Выберите точку самовывоза",
                name: "Имя",
                phone: "Телефон",
                address: "Адрес доставки",
                comment: "Комментарий к заказу"
            },
            placeholders: {
                deliveryRegion: "В какой район доставить?",
                name: "Как к вам обращаться?",
                phone: "+7 000 000 00 00",
                address: "Куда доставить?",
                comment: "Комментарий к заказу"
            },
            errors: {
                deliveryRegion: "* Пожалуйста, выберите район",
                name: "* Пожалуйста, укажите имя",
                phone: {
                    empty: "* Укажите телефон для связи",
                    invalid: "* Кажется телефон указан не верно. Должно быть не менее 5ти цифр"
                },
                address: "* Пожалуйста, укажите адрес",
                comment: "* Добавьте комментарий к заказу",
                pickupPoint: "* Укажите где бы вы хотели забрать заказ",
                required: "* Обязательное поле"
            },
            deliveryInfo: {
                cost: "Стоимость доставки в этот район составит"
            },
            agreement: {
                text: "Продолжая, вы даёте согласие на обработку персональных данных и соглашаетесь с",
                userAgreement: "Пользовательским соглашением",
                and: "и",
                privacyPolicy: "Политикой конфиденциальности"
            }
        },
        modSelector: {
            outOfStock: "нет в наличии"
        },
        variantSelector: {
            chooseOption: 'Выберите вариант'
        },
        notifications: {
            productStopped: 'Временно недоступно',
            maxQuantityExceeded: 'Для этой позиции действует ограничение - не более {max} в заказе'
        }
    },
    en: {
        common: {
            unknownError: 'Unknown error'
        },
        actions: {
            button: 'Call staff',
            popupTitle: 'Call staff',
            popupSubmitButton: 'Submit',
            popupCloseButton: 'Close',
            notifSuccess: 'Request sent',
            notifFailed: 'Error. Please try again',
            notifError: 'An error occurred',
        },
        nav: {
            categories: 'Menu categories',
            favorite: 'Favorite',
            search: 'Search',
            allergens: 'Allergens',
        },
        buttons: {
            addToCart: 'Add to Cart'
        },
        search: {
            placeholder: "Search...",
            nothingFound: "Nothing found"
        },
        order: {
            title: "Place Order",
            success: {
                title: "Done",
                message: "Order successfully placed. We will call you back shortly",
                orderNumber: "Your order number"
            },
            error: {
                title: "Error",
                placement: "Error placing order"
            },
            buttons: {
                return: 'Return to menu',
                retry: 'Retry',
                save: 'Save menu to phone'
            }
        },
        cart: {
            all: "All",
            title: "My Cart",
            empty: "Cart is empty",
            widget: "In Cart",
            itemsCount: "item(s)",
            openMenu: "Open Menu",
            unnamed: "Unnamed",
            notInCart: "not added to cart yet",
            askWaiter: "Please ask the waiter to place the order",
            buttons: {
                retry: "Retry",
                returnToMenu: "Return to Menu",
                saveMenu: "Save Menu to Phone"
            }
        },
        filters: {
            allergens: 'Allergens'
        },
        blocks: {
            recommendations: {
                title: "Recommended",
                empty: "No recommendations"
            },
            favorites: {
                title: "Your Favorites",
                empty: "No favorite dishes"
            },
            total: {
                sum: "Sum",
                delivery: "Delivery",
                deliveryCost: "Delivery cost",
                total: "Total"
            }
        },
        footer: {
            address: "Address",
            contacts: "Contacts",
            map: "Map",
            privacyPolicy: "Privacy Policy",
            termsOfUse: "Terms of Use"
        },
        docs: {
            privacyPolicy: 'Privacy Policy',
            accept: 'I consent to the processing of my personal data in accordance with the Privacy Policy and applicable data protection legislation.'
        },
        legal: {
            title: 'Legal information'
        },
        cartOrder: {
            placeOrder: "Place Order",
            closed: "Restaurant is closed",
            minOrder: "Minimum order",
            minOrderMessage: "Your order amount is below the minimum. To place an order, you need to add items worth at least",
            deliveryClosedMessage: "Unfortunately, the delivery service is currently closed. We will accept your order and process it as soon as it opens.",
            openInMinutes: "Delivery opens in",
            minutes: "min.",
            openAt: "Delivery works from"
        },
        dmLabel: {
            text: "Made with",
        },
        nutrition: {
            title: "Nutrition Facts",
            weight: "Serving size",
            perServing: "per serving",
            addToFavorites: "Add to favorites",
            inFavorites: "In favorites",
            calories: 'cal',
            proteins: 'protein',
            fats: 'fat',
            carbs: 'carbs',
            gram: 'g'
        },
        allergens: {
            contains: 'Contains',
            Cereals: 'Cereals',
            Avocado: 'Avocado',
            Peanuts: 'Peanuts',
            gluten: 'Gluten',
            Mustard: 'Mustard',
            "Sulphur dioxide": 'Sulphur dioxide',
            Sesame: 'Sesame',
            Lupin: 'Lupin',
            Molluscs: 'Molluscs',
            Milk: 'Milk',
            Nuts: 'Nuts',
            Crustaceans: 'Crustaceans',
            Fish: 'Fish',
            Celery: 'Celery',
            Soya: 'Soya',
            Eggs: 'Eggs'
        },
        addToCart: {
            add: "Add",
            added: "Added"
        },
        details: {
            description: "Description",
            ingredients: "Ingredients",
            weight: "Weight",
            close: "Close"
        },
        price: {
            from: "from"
        },
        orderScreen: {
            title: "Place Order",
            buttons: {
                placeOrder: 'Place Order'
            },
            deliveryType: {
                label: "How would you like to receive your order?",
                onsite: "At restaurant",
                delivery: "Delivery to address",
                pickup: "Pickup"
            },
            fields: {
                deliveryRegion: "Delivery area",
                pickupPoint: "Pickup point",
                name: "Name",
                phone: "Phone",
                address: "Delivery address",
                comment: "Order comment"
            },
            placeholders: {
                deliveryRegion: "Which area to deliver to?",
                name: "What should we call you?",
                phone: "+1 000 000 0000",
                address: "Where to deliver?",
                comment: "Order comment"
            },
            errors: {
                deliveryRegion: "* Please select a delivery area",
                name: "* Please enter your name",
                phone: {
                    empty: "* Please provide a contact phone",
                    invalid: "* The phone number seems incorrect. It should have at least 5 digits"
                },
                address: "* Please provide the delivery address",
                comment: "* Please add a comment to your order",
                pickupPoint: "* Please specify where you would like to pick up your order",
                required: "* Required field"
            },
            deliveryInfo: {
                cost: "Delivery cost to this area will be"
            },
            agreement: {
                text: "By continuing, you consent to the processing of personal data and agree to the",
                userAgreement: "User Agreement",
                and: "and",
                privacyPolicy: "Privacy Policy"
            }
        },
        modSelector: {
            outOfStock: "out of stock"
        },
        variantSelector: {
            chooseOption: 'Choose option'
        },
        notifications: {
            productStopped: 'Temporarily unavailable',
            maxQuantityExceeded: 'There is a limit of {max} items per order for this product'
        }
    },
    es: {
        common: {
            unknownError: 'Error desconocido'
        },
        actions: {
            button: 'Llamar al personal',
            popupTitle: 'Llamar al personal',
            popupSubmitButton: 'Enviar',
            popupCloseButton: 'Cerrar',
            notifSuccess: 'Solicitud enviada',
            notifFailed: 'Error. Inténtalo de nuevo',
            notifError: 'Se ha producido un error',
        },
        nav: {
            categories: 'Categorías del menú',
            favorite: 'Favoritos',
            search: 'Búsqueda',
            allergens: 'Alérgenos',
        },
        buttons: {
            addToCart: 'Añadir al Carrito'
        },
        search: {
            placeholder: "Buscar...",
            nothingFound: "No se encontró nada"
        },
        order: {
            title: "Realizar Pedido",
            success: {
                title: "¡Listo!",
                message: "Pedido realizado con éxito. Te llamaremos en breve",
                orderNumber: "Número de tu pedido"
            },
            error: {
                title: "Error",
                placement: "Error al realizar el pedido"
            },
            buttons: {
                return: 'Volver al menú',
                retry: 'Reintentar',
                save: 'Guardar carta en el teléfono'
            }
        },
        cart: {
            all: "Todo",
            title: "Mi Carrito",
            empty: "El carrito está vacío",
            widget: "En el Carrito",
            itemsCount: "platos",
            openMenu: "Abrir Carta",
            unnamed: "Sin nombre",
            notInCart: "aún no está en el carrito",
            askWaiter: "Para realizar el pedido, contacte al camarero",
            buttons: {
                retry: "Reintentar",
                returnToMenu: "Volver a la Carta",
                saveMenu: "Guardar Carta en el Teléfono"
            }
        },
        filters: {
            allergens: 'Alérgenos'
        },
        blocks: {
            recommendations: {
                title: "Recomendados",
                empty: "Sin recomendaciones"
            },
            favorites: {
                title: "Tus Favoritos",
                empty: "Sin platos favoritos"
            },
            total: {
                sum: "Suma",
                delivery: "Entrega",
                deliveryCost: "Costo de entrega",
                total: "Total"
            }
        },
        footer: {
            address: "Dirección",
            contacts: "Contactos",
            map: "Mapa",
            privacyPolicy: "Política de Privacidad",
            termsOfUse: "Términos de Uso"
        },
        docs: {
            privacyPolicy: 'Política de Privacidad',
            accept: 'Doy mi consentimiento para el procesamiento de mis datos personales de acuerdo con la Política de Privacidad y la legislación aplicable sobre protección de datos.'
        },
        legal: {
            title: 'Información legal'
        },
        cartOrder: {
            placeOrder: "Realizar Pedido",
            closed: "Restaurante cerrado",
            minOrder: "Pedido mínimo",
            minOrderMessage: "El monto de su pedido está por debajo del mínimo. Para realizar un pedido, debe agregar artículos por un valor de al menos",
            deliveryClosedMessage: "Desafortunadamente, el servicio de entrega está cerrado actualmente. Aceptaremos su pedido y lo procesaremos tan pronto como abra.",
            openInMinutes: "La entrega abre en",
            minutes: "min.",
            openAt: "La entrega funciona desde"
        },
        dmLabel: {
            text: "Hecho con",
        },
        nutrition: {
            title: "Información Nutricional",
            weight: "Tamaño de porción",
            perServing: "por porción",
            addToFavorites: "Añadir a favoritos",
            inFavorites: "En favoritos",
            calories: 'cal',
            proteins: 'proteínas',
            fats: 'grasas',
            carbs: 'carbohidratos',
            gram: 'g'
        },
        allergens: {
            contains: 'Contiene',
            Cereals: 'Cereales',
            Avocado: 'Aguacate',
            Peanuts: 'Cacahuetes',
            gluten: 'Gluten',
            Mustard: 'Mostaza',
            "Sulphur dioxide": 'Dióxido de azufre',
            Sesame: 'Sésamo',
            Lupin: 'Altramuz',
            Molluscs: 'Moluscos',
            Milk: 'Leche',
            Nuts: 'Frutos secos',
            Crustaceans: 'Crustáceos',
            Fish: 'Pescado',
            Celery: 'Apio',
            Soya: 'Soja',
            Eggs: 'Huevos'
        },
        addToCart: {
            add: "Añadir",
            added: "Añadido"
        },
        details: {
            description: "Descripción",
            ingredients: "Ingredientes",
            weight: "Peso",
            close: "Cerrar"
        },
        price: {
            from: "desde"
        },
        orderScreen: {
            title: "Realizar Pedido",
            buttons: {
                placeOrder: 'Realizar Pedido'
            },
            deliveryType: {
                label: "¿Cómo desea recibir su pedido?",
                onsite: "En el local",
                delivery: "Entrega a domicilio",
                pickup: "Para llevar"
            },
            fields: {
                deliveryRegion: "Zona de entrega",
                pickupPoint: "Punto de recogida",
                name: "Nombre",
                phone: "Teléfono",
                address: "Dirección de entrega",
                comment: "Comentario del pedido"
            },
            placeholders: {
                deliveryRegion: "¿A qué zona entregar?",
                name: "¿Cómo debemos llamarte?",
                phone: "+34 000 000 000",
                address: "¿Dónde entregar?",
                comment: "Comentario del pedido"
            },
            errors: {
                deliveryRegion: "* Por favor, seleccione una zona de entrega",
                name: "* Por favor, ingrese su nombre",
                phone: {
                    empty: "* Proporcione un teléfono de contacto",
                    invalid: "* El número de teléfono parece incorrecto. Debe tener al menos 5 dígitos"
                },
                address: "* Por favor, proporcione la dirección de entrega",
                comment: "* Por favor, agregue un comentario a su pedido",
                pickupPoint: "* Especifique dónde le gustaría recoger su pedido",
                required: "* Campo obligatorio"
            },
            deliveryInfo: {
                cost: "El costo de entrega a esta zona será"
            },
            agreement: {
                text: "Al continuar, acepta el procesamiento de datos personales y está de acuerdo con el",
                userAgreement: "Acuerdo de Usuario",
                and: "y",
                privacyPolicy: "Política de Privacidad"
            }
        },
        modSelector: {
            outOfStock: "agotado"
        },
        variantSelector: {
            chooseOption: 'Seleccione opción'
        },
        notifications: {
            productStopped: 'Temporalmente no disponible',
            maxQuantityExceeded: 'Hay un límite de {max} artículos por pedido para este producto'
        }
    },
    uz: {
        common: {
            unknownError: 'Nomaʼlum xato'
        },
        actions: {
            button: 'Xodimni chaqirish',
            popupTitle: 'Xodimni chaqirish',
            popupSubmitButton: 'Yuborish',
            popupCloseButton: 'Yopish',
            notifSuccess: "So‘rov yuborildi",
            notifFailed: 'Xatolik. Qayta urinib ko‘ring',
            notifError: 'Xatolik yuz berdi',
        },
        nav: {
            categories: 'Menyu bo‘limlari',
            favorite: 'Sevimlilar',
            search: 'Qidiruv',
            allergens: 'Allergenlar',
        },
        buttons: {
            addToCart: 'Savatchaga qo\'shish'
        },
        search: {
            placeholder: "Qidirish...",
            nothingFound: "Hech narsa topilmadi"
        },
        order: {
            title: "Buyurtma berish",
            success: {
                title: "Tayyor!",
                message: "Buyurtma muvaffaqiyatli joylashtirildi. Tez orada sizga qo'ng'iroq qilamiz",
                orderNumber: "Buyurtma raqamingiz"
            },
            error: {
                title: "Xato",
                placement: "Buyurtmani joylashtrishda xato"
            },
            buttons: {
                return: 'Menyuga qaytish',
                retry: 'Qayta urinish',
                save: 'Menyuni telefonga saqlash'
            }
        },
        cart: {
            all: "Hammasi",
            title: "Savatcha",
            empty: "Savatcha bo'sh",
            widget: "Savatchada",
            itemsCount: "taom(lar)",
            openMenu: "Menyuni ochish",
            unnamed: "Nomsiz",
            notInCart: "hali savatchaga qo'shilmagan",
            askWaiter: "Buyurtma berish uchun ofitsiantga murojaat qiling",
            buttons: {
                retry: "Qayta urinish",
                returnToMenu: "Menyuga qaytish",
                saveMenu: "Menyuni telefonga saqlash"
            }
        },
        filters: {
            allergens: 'Allergenlar'
        },
        blocks: {
            recommendations: {
                title: "Tavsiya etiladi",
                empty: "Tavsiyalar yo'q"
            },
            favorites: {
                title: "Sevimli taomlaringiz",
                empty: "Sevimli taomlar yo'q"
            },
            total: {
                sum: "Summa",
                delivery: "Yetkazib berish",
                deliveryCost: "Yetkazib berish narxi",
                total: "Jami"
            }
        },
        footer: {
            address: "Manzil",
            contacts: "Kontaktlar",
            map: "Xarita",
            privacyPolicy: "Maxfiylik siyosati",
            termsOfUse: "Foydalanish shartlari"
        },
        docs: {
            privacyPolicy: 'Maxfiylik siyosati',
            accept: 'Men shaxsiy ma\'lumotlarimni Maxfiylik siyosati va ma\'lumotlarni himoya qilish bo\'yicha qo\'llaniladigan qonunchilikka muvofiq qayta ishlashga rozilik beraman.'
        },
        legal: {
            title: 'Huquqiy ma\'lumot'
        },
        cartOrder: {
            placeOrder: "Buyurtma berish",
            closed: "Restoran yopiq",
            minOrder: "Minimal buyurtma",
            minOrderMessage: "Buyurtmangiz summasi minimaldan past. Buyurtma berish uchun savatchaga kamida quyidagi summaga teng mahsulotlarni qo'shishingiz kerak",
            deliveryClosedMessage: "Afsuski, yetkazib berish xizmati hozir yopiq. Buyurtmangizni qabul qilamiz va xizmat ochilishi bilan darhol qayta ishlaymiz.",
            openInMinutes: "Yetkazib berish xizmati ochilishiga",
            minutes: "daq.",
            openAt: "Yetkazib berish xizmati ishlaydigan vaqt"
        },
        dmLabel: {
            text: "Bu menyu platformada yaratilgan",
        },
        nutrition: {
            title: "Ozuqaviy qiymat",
            weight: "Porsiya hajmi",
            perServing: "porsiyaga",
            addToFavorites: "Sevimlilarga qo'shish",
            inFavorites: "Sevimlilarda",
            calories: 'kkal',
            proteins: 'oqsillar',
            fats: 'yog\'lar',
            carbs: 'uglevodlar',
            gram: 'g'
        },
        allergens: {
            contains: 'Tarkibida bor',
            Cereals: 'Don mahsulotlari',
            Avocado: 'Avokado',
            Peanuts: 'Yeryong\'oq',
            gluten: 'Gluten',
            Mustard: 'Xantal',
            "Sulphur dioxide": 'Oltingugurt dioksidi',
            Sesame: 'Kunjut',
            Lupin: 'Lupin',
            Molluscs: 'Mollyuskalar',
            Milk: 'Sut',
            Nuts: 'Yong\'oqlar',
            Crustaceans: 'Qisqichbaqasimonlar',
            Fish: 'Baliq',
            Celery: 'Selderey',
            Soya: 'Soya',
            Eggs: 'Tuxum'
        },
        addToCart: {
            add: "Qo'shish",
            added: "Qo'shildi"
        },
        details: {
            description: "Tavsif",
            ingredients: "Tarkibi",
            weight: "Og'irligi",
            close: "Yopish"
        },
        price: {
            from: "dan"
        },
        orderScreen: {
            title: "Buyurtma berish",
            buttons: {
                placeOrder: 'Buyurtma berish'
            },
            deliveryType: {
                label: "Buyurtmani qanday olishni xohlaysiz?",
                onsite: "Joyida",
                delivery: "Yetkazib berish",
                pickup: "Olib ketish"
            },
            fields: {
                deliveryRegion: "Yetkazib berish hududi",
                pickupPoint: "Olib ketish punkti",
                name: "Ism",
                phone: "Telefon",
                address: "Yetkazib berish manzili",
                comment: "Buyurtmaga izoh"
            },
            placeholders: {
                deliveryRegion: "Qaysi tumanga yetkazib berish kerak?",
                name: "Sizni nima deb chaqirishimiz mumkin?",
                phone: "+998 00 000 00 00",
                address: "Qayerga yetkazib berish kerak?",
                comment: "Buyurtmaga izoh"
            },
            errors: {
                deliveryRegion: "* Iltimos, yetkazib berish tumanini tanlang",
                name: "* Iltimos, ismingizni kiriting",
                phone: {
                    empty: "* Aloqa uchun telefon raqamini kiriting",
                    invalid: "* Telefon raqami noto'g'ri ko'rinadi. Kamida 5 ta raqam bo'lishi kerak"
                },
                address: "* Iltimos, yetkazib berish manzilini kiriting",
                comment: "* Iltimos, buyurtmangizga izoh qo'shing",
                pickupPoint: "* Buyurtmani qayerdan olishni xohlashingizni ko'rsating",
                required: "* Majburiy maydon"
            },
            deliveryInfo: {
                cost: "Ushbu tumanga yetkazib berish narxi"
            },
            agreement: {
                text: "Davom etish orqali siz shaxsiy ma'lumotlarni qayta ishlashga rozilik bildirasiz va quyidagilar bilan kelishasiz",
                userAgreement: "Foydalanuvchi kelishuvi",
                and: "va",
                privacyPolicy: "Maxfiylik siyosati"
            }
        },
        modSelector: {
            outOfStock: "mavjud emas"
        },
        variantSelector: {
            chooseOption: 'Variantni tanlang'
        },
        notifications: {
            productStopped: 'Vaqtincha mavjud emas',
            maxQuantityExceeded: 'Ushbu mahsulot uchun buyurtma birligi {max} tadan oshmasligi kerak'
        }
    },
    kk: {
        common: {
            unknownError: 'Белгісіз қате'
        },
        actions: {
            button: 'Қызметкерді шақыру',
            popupTitle: 'Қызметкерді шақыру',
            popupSubmitButton: 'Жіберу',
            popupCloseButton: 'Жабу',
            notifSuccess: 'Сұраныс жіберілді',
            notifFailed: 'Қате. Қайта көріңіз',
            notifError: 'Қате орын алды',
        },
        nav: {
            categories: 'Мәзір бөлімдері',
            favorite: 'Таңдаулылар',
            search: 'Іздеу',
            allergens: 'Аллергендер',
        },
        buttons: {
            addToCart: 'Себетке қосу'
        },
        search: {
            placeholder: "Іздеу...",
            nothingFound: "Ештеңе табылмады"
        },
        order: {
            title: "Тапсырыс беру",
            success: {
                title: "Дайын!",
                message: "Тапсырыс сәтті орналастырылды. Жақын арада сізге қоңырау шаламыз",
                orderNumber: "Тапсырыс нөіріңіз"
            },
            error: {
                title: "Қате",
                placement: "Тапсырысты орналастыру қатесі"
            },
            buttons: {
                return: 'Мәзірге оралу',
                retry: 'Қайталап көру',
                save: 'Мәзірді телефонға сақтау'
            }
        },
        cart: {
            all: "Барлығы",
            title: "Себет",
            empty: "Себет бос",
            widget: "Себетте",
            itemsCount: "тағам(дар)",
            openMenu: "Мәзірді ашу",
            unnamed: "Атаусыз",
            notInCart: "әлі себетке қосылған жоқ",
            askWaiter: "Тапсырыс беру үшін даяшыға жүгініңіз",
            buttons: {
                retry: "Қайталау",
                returnToMenu: "Мәзірге оралу",
                saveMenu: "Мәзірді телефонға сақтау"
            }
        },
        filters: {
            allergens: 'Аллергендер'
        },
        blocks: {
            recommendations: {
                title: "Ұсынылады",
                empty: "Ұсыныстар жоқ"
            },
            favorites: {
                title: "Сіздің сүйікті тағамдарыңыз",
                empty: "Сүйікті тағамдар жоқ"
            },
            total: {
                sum: "Сома",
                delivery: "Жеткізу",
                deliveryCost: "Жеткізу құны",
                total: "Барлығы"
            }
        },
        footer: {
            address: "Мекенжай",
            contacts: "Байланыстар",
            map: "Карта",
            privacyPolicy: "Құпиялылық саясаты",
            termsOfUse: "Қолдану ережелері"
        },
        docs: {
            privacyPolicy: 'Құпиялылық саясаты',
            accept: 'Мен жеке деректерімді Құпиялылық саясаты және деректерді қорғау бойынша қолданылатын заңнамаға сәйкес өңдеуге келісім беремін.'
        },
        legal: {
            title: 'Құқықтық ақпарат'
        },
        cartOrder: {
            placeOrder: "Тапсырыс беру",
            closed: "Мейрамхана жабық",
            minOrder: "Минималды тапсырыс",
            minOrderMessage: "Сіздің тапсырысыңыздың сомасы минималды мөлшерден төмен. Тапсырыс беру үшін себетке кем дегенде мынадай сомаға тауар қосу керек",
            deliveryClosedMessage: "Өкінішке орай, жеткізу қызметі қазір жабық. Біз сіздің тапсырысыңызды қабылдаймыз және ол ашылған бойда өңдейміз.",
            openInMinutes: "Жеткізу қызметі ашылуына",
            minutes: "мин.",
            openAt: "Жеткізу қызметі жұмыс істейтін уақыт"
        },
        dmLabel: {
            text: "Бұл мәзір платформада жасалған",
        },
        nutrition: {
            title: "Тағамдық құндылығы",
            weight: "Порция мөлшері",
            perServing: "порцияға",
            addToFavorites: "Таңдаулыларға қосу",
            inFavorites: "Таңдаулыларда",
            calories: 'ккал',
            proteins: 'ақуыздар',
            fats: 'майлар',
            carbs: 'көмірсулар',
            gram: 'г'
        },
        allergens: {
            contains: 'Құрамында бар',
            Cereals: 'Дәнді дақылдар',
            Avocado: 'Авокадо',
            Peanuts: 'Жержаңғақ',
            gluten: 'Глютен',
            Mustard: 'Қыша',
            "Sulphur dioxide": 'Күкірт диоксиді',
            Sesame: 'Күнжіт',
            Lupin: 'Люпин',
            Molluscs: 'Моллюскалар',
            Milk: 'Сүт',
            Nuts: 'Жаңғақтар',
            Crustaceans: 'Шаян тәрізділер',
            Fish: 'Балық',
            Celery: 'Балдыркөк',
            Soya: 'Соя',
            Eggs: 'Жұмыртқа'
        },
        addToCart: {
            add: "Қосу",
            added: "Қосылды"
        },
        details: {
            description: "Сипаттама",
            ingredients: "Құрамы",
            weight: "Салмағы",
            close: "Жабу"
        },
        price: {
            from: "бастап"
        },
        orderScreen: {
            title: "Тапсырыс беру",
            buttons: {
                placeOrder: 'Тапсырыс беру'
            },
            deliveryType: {
                label: "Тапсырысты қалай алғыңыз келеді?",
                onsite: "Орнында",
                delivery: "Жеткізу",
                pickup: "Алып кету"
            },
            fields: {
                deliveryRegion: "Жеткізу ауданы",
                pickupPoint: "Алып кету пункті",
                name: "Аты",
                phone: "Телефон",
                address: "Жеткізу мекенжайы",
                comment: "Тапсырысқа түсініктеме"
            },
            placeholders: {
                deliveryRegion: "Қай ауданға жетkізу керек?",
                name: "Sizni nima deb chaqirishimiz mumkin?",
                phone: "+7 000 000 00 00",
                address: "Қайда жетkізу керек?",
                comment: "Тапсырысқа түсініkтеме"
            },
            errors: {
                deliveryRegion: "* Жеткізу ауданын таңдаңыз",
                name: "* Атыңызды енгізіңіз",
                phone: {
                    empty: "* Байланыс телефонын көрсетіңіз",
                    invalid: "* Телефон нөмірі дұрыс емес сияқты. Кем дегенде 5 сан болуы керек"
                },
                address: "* Жеткізу мекенжайын көрсетіңіз",
                comment: "* Тапсырысқа түсініkтеме қосыңыз",
                pickupPoint: "* Тапсырысты қайдан алғыңыз келетінін көрсетіңіз",
                required: "* Міндетті өріс"
            },
            deliveryInfo: {
                cost: "Бұл ауданға жетkізу құны"
            },
            agreement: {
                text: "Жалғастыру арқылы сіз жеке деректерді өңдеуге келісім бересіз және келесілермен келісесіз",
                userAgreement: "Қолданушы келісімі",
                and: "және",
                privacyPolicy: "Құпиялылық саясаты"
            }
        },
        modSelector: {
            outOfStock: "қолжетімді емес"
        },
        variantSelector: {
            chooseOption: 'Нұсқаны таңдаңыз'
        },
        notifications: {
            productStopped: 'Уақытша қолжетімсіз',
            maxQuantityExceeded: 'Бұл тауар үшін тапсырыс бірлігі {max} тардан аспауы керек'
        }
    },
    be: {
        common: {
            unknownError: 'Невядомая памылка'
        },
        actions: {
            button: 'Выклік персаналу',
            popupTitle: 'Выклік персаналу',
            popupSubmitButton: 'Адправіць',
            popupCloseButton: 'Закрыць',
            notifSuccess: 'Запыт адпраўлены',
            notifFailed: 'Памылка. Паспрабуйце яшчэ раз',
            notifError: 'Адбылася памылка',
        },
        nav: {
            categories: 'Раздзелы меню',
            favorite: 'Абранае',
            search: 'Пошук',
            allergens: 'Алергены',
        },
        buttons: {
            addToCart: 'Дадаць у кошык'
        },
        search: {
            placeholder: "Пошук...",
            nothingFound: "Нічога не знойдзена"
        },
        order: {
            title: "Афармленне заказу",
            success: {
                title: "Гатова",
                message: "Заказ паспяхова аформлены. Мы патэлефануем вам у бліжэйшы час",
                orderNumber: "Нумар вашага заказу"
            },
            error: {
                title: "Памылка",
                placement: "Памылка размяшчэння заказу"
            },
            buttons: {
                return: 'Вярнуцца ў меню',
                retry: 'Паўтарыць спробу',
                save: 'Захаваць меню на тэлефон'
            }
        },
        cart: {
            all: "Усё",
            title: "Мой кошык",
            empty: "У кошыку няма пазіцый",
            widget: "У кошыку",
            itemsCount: "страв(ы)",
            openMenu: "Адкрыць меню",
            unnamed: "Без назвы",
            notInCart: "яшчэ не дададзена ў кошык",
            askWaiter: "Для афармлення заказу звярніцеся да афіцыянта",
            buttons: {
                retry: "Паўтарыць спробу",
                returnToMenu: "Вярнуцца ў меню",
                saveMenu: "Захаваць меню на тэлефон"
            }
        },
        filters: {
            allergens: 'Алергены'
        },
        blocks: {
            recommendations: {
                title: "Рэкамендуем",
                empty: "Няма рэкамендацый"
            },
            favorites: {
                title: "Вашы любімыя стравы",
                empty: "Няма абраных страў"
            },
            total: {
                sum: "Сума",
                delivery: "Дастаўка",
                deliveryCost: "Кошт дастаўкі",
                total: "Усяго"
            }
        },
        footer: {
            address: "Адрас",
            contacts: "Кантакты",
            map: "Карта",
            privacyPolicy: "Палітыка прыватнасці",
            termsOfUse: "Карыстальніцкае пагадненне"
        },
        docs: {
            privacyPolicy: 'Палітыка прыватнасці',
            accept: 'Я даю згоду на апрацоўку маіх персанальных дадзеных у адпаведнасці з Палітыкай прыватнасці і прыдатным заканадаўствам аб абароне дадзеных.'
        },
        legal: {
            title: 'Правовая інформацыя'
        },
        cartOrder: {
            placeOrder: "Аформіць заказ",
            closed: "Рэстаран зачынены",
            minOrder: "Мінімальны заказ",
            minOrderMessage: "Сума вашага заказу ніжэй мінімальнай. Для афармлення заказу вам неабходна дадаць у кошык тавары на суму не менш",
            deliveryClosedMessage: "На жаль, зараз служба дастаўкі не працуе, мы прымем ваш заказ і апрацуем яго адразу, як толькі яна адкрыецца.",
            openInMinutes: "Дастаўка адкрыецца праз",
            minutes: "хв.",
            openAt: "Дастаўка працуе з"
        },
        dmLabel: {
            text: "Гэта меню зроблена на платформе",
        },
        nutrition: {
            title: "Харчовая каштоўнасць",
            weight: "Вага порцыі",
            perServing: "на порцыю",
            addToFavorites: "У абранае",
            inFavorites: "У абраным",
            calories: 'ккал',
            proteins: 'бялкі',
            fats: 'тлушчы',
            carbs: 'вугляводы',
            gram: 'г'
        },
        allergens: {
            contains: 'Змяшчае',
            Cereals: 'Злакі',
            Avocado: 'Авакада',
            Peanuts: 'Арахіс',
            gluten: 'Глютэн',
            Mustard: 'Гарчыца',
            "Sulphur dioxide": 'Дыяксід серы',
            Sesame: 'Кунжут',
            Lupin: 'Люпін',
            Molluscs: 'Малюскі',
            Milk: 'Малако',
            Nuts: 'Арэхі',
            Crustaceans: 'Ракападобныя',
            Fish: 'Рыба',
            Celery: 'Сельдэрэй',
            Soya: 'Соя',
            Eggs: 'Яйкі'
        },
        addToCart: {
            add: "Дадаць",
            added: "Дададзена"
        },
        details: {
            description: "Апісанне",
            ingredients: "Склад",
            weight: "Вага",
            close: "Закрыць"
        },
        price: {
            from: "ад"
        },
        orderScreen: {
            title: "Афармленне заказу",
            buttons: {
                placeOrder: 'Аформіць заказ'
            },
            deliveryType: {
                label: "Як вы хочаце атрымаць заказ?",
                onsite: "У закладзе",
                delivery: "Даставіць па адрасе",
                pickup: "Самавываз"
            },
            fields: {
                deliveryRegion: "Раён дастаўкі",
                pickupPoint: "Пункт самавывазу",
                name: "Імя",
                phone: "Тэлефон",
                address: "Адрас дастаўкі",
                comment: "Каментар да заказу"
            },
            placeholders: {
                deliveryRegion: "У які раён даставіць?",
                name: "Як да вас звяртацца?",
                phone: "+375 00 000 00 00",
                address: "Куды даставіць?",
                comment: "Каментар да заказу"
            },
            errors: {
                deliveryRegion: "* Калі ласка, выберыце раён",
                name: "* Калі ласка, укажыце імя",
                phone: {
                    empty: "* Укажыце тэлефон для сувязі",
                    invalid: "* Здаецца, тэлефон указаны няправільна. Павінна быць не менш за 5 лічбаў"
                },
                address: "* Калі ласка, укажыце адрас",
                comment: "* Дадайце каментар да заказу",
                pickupPoint: "* Укажыце, дзе б вы хацелі забраць заказ",
                required: "* Абавязковае поле"
            },
            deliveryInfo: {
                cost: "Кошт дастаўкі ў гэты раён складзе"
            },
            agreement: {
                text: "Працягваючы, вы даяце згоду на апрацоўку персанальных дадзеных і пагаджаецеся з",
                userAgreement: "Карыстальніцкім пагадненнем",
                and: "і",
                privacyPolicy: "Палітыкай прыватнасці"
            }
        },
        modSelector: {
            outOfStock: "няма ў наяўнасці"
        },
        variantSelector: {
            chooseOption: 'Выберыце варыянт'
        },
        notifications: {
            productStopped: 'Часова недаступны',
            maxQuantityExceeded: 'Для гэтага тавару ёсць абмежаванне ў {max} адзінак за заказ'
        }
    },
    tr: {
        common: {
            unknownError: 'Bilinmeyen hata'
        },
        actions: {
            button: 'Personel çağır',
            popupTitle: 'Personel çağır',
            popupSubmitButton: 'Gönder',
            popupCloseButton: 'Kapat',
            notifSuccess: 'İstek gönderildi',
            notifFailed: 'Hata. Lütfen tekrar deneyin',
            notifError: 'Bir hata oluştu',
        },
        nav: {
            categories: 'Menü bölümleri',
            favorite: 'Favoriler',
            search: 'Arama',
            allergens: 'Alerjenler',
        },
        buttons: {
            addToCart: 'Sepete Ekle'
        },
        search: {
            placeholder: "Ara...",
            nothingFound: "Hiçbir şey bulunamadı"
        },
        order: {
            title: "Sipariş Ver",
            success: {
                title: "Hazır",
                message: "Sipariş başarıyla oluşturuldu. En kısa sürede sizi arayacağız",
                orderNumber: "Sipariş numaranız"
            },
            error: {
                title: "Hata",
                placement: "Sipariş oluşturma hatası"
            },
            buttons: {
                return: 'Menüye dön',
                retry: 'Tekrar dene',
                save: 'Menüyü telefona kaydet'
            }
        },
        cart: {
            all: "Tümü",
            title: "Sepetim",
            empty: "Sepetiniz boş",
            widget: "Sepette",
            itemsCount: "ürün",
            openMenu: "Menüyü Aç",
            unnamed: "İsimsiz",
            notInCart: "henüz sepete eklenmedi",
            askWaiter: "Sipariş vermek için garsona bildiriniz",
            buttons: {
                retry: "Tekrar Dene",
                returnToMenu: "Menüye Dön",
                saveMenu: "Menüyü Telefona Kaydet"
            }
        },
        filters: {
            allergens: 'Alerjenler'
        },
        blocks: {
            recommendations: {
                title: "Öneriler",
                empty: "Öneri yok"
            },
            favorites: {
                title: "Favori Yemekleriniz",
                empty: "Favori yemek yok"
            },
            total: {
                sum: "Toplam",
                delivery: "Teslimat",
                deliveryCost: "Teslimat ücreti",
                total: "Genel Toplam"
            }
        },
        footer: {
            address: "Adres",
            contacts: "İletişim",
            map: "Harita",
            privacyPolicy: "Gizlilik Politikası",
            termsOfUse: "Kullanım Koşulları"
        },
        docs: {
            privacyPolicy: 'Gizlilik Politikası',
            accept: 'Gizlilik Politikası ve uygulanabilir veri koruma mevzuatına uygun olarak kişisel verilerimin işlenmesine izin veriyorum.'
        },
        legal: {
            title: 'Yasal bilgiler'
        },
        cartOrder: {
            placeOrder: "Sipariş Ver",
            closed: "Restoran kapalı",
            minOrder: "Minimum sipariş",
            minOrderMessage: "Sipariş tutarınız minimum tutarın altında. Sipariş verebilmek için sepetinize en az şu tutarda ürün eklemeniz gerekiyor",
            deliveryClosedMessage: "Üzgünüz, teslimat servisi şu anda kapalı. Siparişinizi alacağız ve servis açıldığında hemen işleme koyacağız.",
            openInMinutes: "Teslimat açılışına",
            minutes: "dk.",
            openAt: "Teslimat çalışma saatleri"
        },
        dmLabel: {
            text: "Bu menü platformunda yapılmıştır",
        },
        nutrition: {
            title: "Besin Değerleri",
            weight: "Porsiyon büyüklüğü",
            perServing: "porsiyon başına",
            addToFavorites: "Favorilere Ekle",
            inFavorites: "Favorilerde",
            calories: 'kcal',
            proteins: 'protein',
            fats: 'yağ',
            carbs: 'karbonhidrat',
            gram: 'g'
        },
        allergens: {
            contains: 'İçerir',
            Cereals: 'Tahıllar',
            Avocado: 'Avokado',
            Peanuts: 'Yer fıstığı',
            gluten: 'Gluten',
            Mustard: 'Hardal',
            "Sulphur dioxide": 'Kükürt dioksit',
            Sesame: 'Susam',
            Lupin: 'Acı bakla',
            Molluscs: 'Yumuşakçalar',
            Milk: 'Süt',
            Nuts: 'Kuruyemişler',
            Crustaceans: 'Kabuklular',
            Fish: 'Balık',
            Celery: 'Kereviz',
            Soya: 'Soya',
            Eggs: 'Yumurta'
        },
        addToCart: {
            add: "Ekle",
            added: "Eklendi"
        },
        details: {
            description: "Açıklama",
            ingredients: "İçindekiler",
            weight: "Ağırlık",
            close: "Kapat"
        },
        price: {
            from: "den itibaren"
        },
        orderScreen: {
            title: "Sipariş Ver",
            buttons: {
                placeOrder: 'Sipariş ver'
            },
            deliveryType: {
                label: "Siparişinizi nasıl almak istersiniz?",
                onsite: "Restoranda",
                delivery: "Adrese Teslimat",
                pickup: "Gel Al"
            },
            fields: {
                deliveryRegion: "Teslimat bölgesi",
                pickupPoint: "Teslim alma noktası",
                name: "İsim",
                phone: "Telefon",
                address: "Teslimat adresi",
                comment: "Sipariş notu"
            },
            placeholders: {
                deliveryRegion: "Hangi bölgeye teslim edilecek?",
                name: "Size nasıl hitap edelim?",
                phone: "+90 000 000 00 00",
                address: "Sırayla teslim edilecek?",
                comment: "Sipariş notu"
            },
            errors: {
                deliveryRegion: "* Lütfen teslimat bölgesi seçin",
                name: "* Lütfen isminizi girin",
                phone: {
                    empty: "* İletişim için telefon numarası girin",
                    invalid: "* Telefon numarası hatalı görünüyor. En az 5 rakam olmalı"
                },
                address: "* Lütfen teslimat adresini girin",
                comment: "* Lütfen siparişinize not ekleyin",
                pickupPoint: "* Lütfen siparişinizi nereden almak istediğinizi belirtin",
                required: "* Zorunlu alan"
            },
            deliveryInfo: {
                cost: "Teslimat ücreti bu bölgede"
            },
            agreement: {
                text: "Devam ederek, kişisel verilerin işlenmesini kabul ediyorsunuz ve",
                userAgreement: "Kullanıcı Sözleşmesi",
                and: "ve",
                privacyPolicy: "Gizlilik Politikası"
            }
        },
        modSelector: {
            outOfStock: "stokta yok"
        },
        variantSelector: {
            chooseOption: 'Seçenek belirleyin'
        },
        notifications: {
            productStopped: 'Geçici olarak mevcut değil',
            maxQuantityExceeded: 'Bu ürün için sipariş başına {max} adet limiti vardır'
        }
    },
    ka: {
        common: {
            unknownError: 'უცნობი შეცდომა'
        },
        actions: {
            button: 'პერსონალის გამოძახება',
            popupTitle: 'პერსონალის გამოძახება',
            popupSubmitButton: 'გაგზავნა',
            popupCloseButton: 'დახურვა',
            notifSuccess: 'მოთხოვნა გაგზავნილია',
            notifFailed: 'შეცდომა. სცადეთ თავიდან',
            notifError: 'დაფიქსირდა შეცდომა',
        },
        nav: {
            categories: 'მენიუს კატეგორიები',
            favorite: 'რჩეულები',
            search: 'ძიება',
            allergens: 'ალერგენები',
        },
        buttons: {
            addToCart: 'კალათაში დამატება'
        },
        search: {
            placeholder: "ძიება...",
            nothingFound: "არაფერი მოიძებნა"
        },
        order: {
            title: "შეკვეთის გაფორმება",
            success: {
                title: "მზადაა",
                message: "შეკვეთა წარმატებით გაფორმდა. უახლოეს დროში დაგიკავშირდებით",
                orderNumber: "თქვენი შეკვეთის ნომერი"
            },
            error: {
                title: "შეცდომა",
                placement: "შეკვეთის განთავსების შეცდომა"
            },
            buttons: {
                return: 'მენიუში დაბრუნება',
                retry: 'ხელახლა ცდა',
                save: 'მენიუს ტელეფონში შენახვა'
            }
        },
        cart: {
            all: "ყველა",
            title: "ჩემი კალათა",
            empty: "კალათა ცარიელია",
            widget: "კალათაში",
            itemsCount: "კერძი(ები)",
            openMenu: "მენიუს გახსნა",
            unnamed: "უსახელო",
            notInCart: "ჯერ კალათაში არ არის დამატებული",
            askWaiter: "შეკვეთისთვის მიმართეთ მიმტანს",
            buttons: {
                retry: "ხელახლა ცდა",
                returnToMenu: "მენიუში დაბრუნება",
                saveMenu: "მენიუს შენახვა ტელეფონში"
            }
        },
        filters: {
            allergens: 'ალერგენები'
        },
        blocks: {
            recommendations: {
                title: "რეკომენდებული",
                empty: "რეკომენდაციები არ არის"
            },
            favorites: {
                title: "თქვენი საყვარელი კერძები",
                empty: "საყვარელი კერძები არ არის"
            },
            total: {
                sum: "ჯამი",
                delivery: "მიტანა",
                deliveryCost: "მიტანის საფასური",
                total: "სულ"
            }
        },
        footer: {
            address: "მისამართი",
            contacts: "კონტაქტები",
            map: "რუკა",
            privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
            termsOfUse: "მოხმარების პირობები"
        },
        docs: {
            privacyPolicy: 'კონფიდენციალურობის პოლიტიკა',
            accept: 'ვთანხმდები ჩემი პერსონალური მონაცემების დამუშავებას კონფიდენციალურობის პოლიტიკისა და მონაცემთა დაცვის შესაბამისი კანონმდებლობის შესაბამისად.'
        },
        legal: {
            title: 'იურიდიული ინფორმაცია'
        },
        cartOrder: {
            placeOrder: "შეკვეთის განთავსება",
            closed: "რესტორანი დახურულია",
            minOrder: "მინიმალური შეკვეთა",
            minOrderMessage: "თქვენი შეკვეთის თანხა მინიმალურზე ნაკლებია. შეკვეთის გასაფორმებლად საჭიროა კალათაში დაამატოთ პროდუქტები მინიმუმ",
            deliveryClosedMessage: "სამწუხაროდ, ამჟამად მიტანის სერვისი არ მუშაობს, ჩვენ მივიღებთ თქვენს შეკვეთას და დავამუშავებთ მას სერვისის გახსნისთანავე.",
            openInMinutes: "მიტანის სერვისი გაიხსნება",
            minutes: "წთ.",
            openAt: "მიტანის სერვისი მუშაობს"
        },
        dmLabel: {
            text: "ეს მენიუ შექმნილია პლატფორმაზე",
        },
        nutrition: {
            title: "კვებითი ღირებულება",
            weight: "პორციის ზომა",
            perServing: "პორციაზე",
            addToFavorites: "ფავორიტებში დამატება",
            inFavorites: "ფავორიტებში",
            calories: 'კკალ',
            proteins: 'ცილები',
            fats: 'ცხიმები',
            carbs: 'ნახშირწყლები',
            gram: 'გ'
        },
        allergens: {
            contains: 'შეიცავს',
            Cereals: 'მარცვლეული',
            Avocado: 'ავოკადო',
            Peanuts: 'არაქისი',
            gluten: 'გლუტენი',
            Mustard: 'მდოგვი',
            "Sulphur dioxide": 'გოგირდის დიოქსიდი',
            Sesame: 'სეზამი',
            Lupin: 'ლუპინი',
            Molluscs: 'მოლუსკები',
            Milk: 'რძე',
            Nuts: 'თხილეული',
            Crustaceans: 'კიბოსნაირნი',
            Fish: 'თევზი',
            Celery: 'ნიახური',
            Soya: 'სოია',
            Eggs: 'კვერცხი'
        },
        addToCart: {
            add: "დამატება",
            added: "დამატებულია"
        },
        details: {
            description: "აღწერა",
            ingredients: "შემადგენლობა",
            weight: "წონა",
            close: "დახურვა"
        },
        price: {
            from: "დან"
        },
        orderScreen: {
            title: "შეკვეთის გაფორმება",
            buttons: {
                placeOrder: 'შეკვეთის განთავსება'
            },
            deliveryType: {
                label: "როგორ გსურთ შეკვეთის მიღება?",
                onsite: "ადგილზე",
                delivery: "მისამართზე მიტანა",
                pickup: "თვითგატანა"
            },
            fields: {
                deliveryRegion: "მიტანის რაიონი",
                pickupPoint: "გატანის პუნქტი",
                name: "სახელი",
                phone: "ტელეფონი",
                address: "მიტანის მისამართი",
                comment: "კომენტარი შეკვეთაზე"
            },
            placeholders: {
                deliveryRegion: "რომელ რაიონში მივიტანოთ?",
                name: "როგორ მოგმართოთ?",
                phone: "+995 000 000 000",
                address: "სად მივიტანოთ?",
                comment: "კომენტარი შეკვეთაზე"
            },
            errors: {
                deliveryRegion: "* გთხოვთ, აირჩიოთ რაიონი",
                name: "* გთხოვთ, მიუთითოთ სახელი",
                phone: {
                    empty: "* მიუთითეთ საკონტაქტო ტელეფონი",
                    invalid: "* ტელეფონის ნომერი არასწორად არის მითითებული. უნდა იყოს მინიმუმ 5 ციფრი"
                },
                address: "* გთხოვთ, მიუთითოთ მისამართი",
                comment: "* დაამატეთ კომენტარი შეკვეთაზე",
                pickupPoint: "* მიუთითეთ, სად გსურთ შეკვეთის გატანა",
                required: "* სავალდებულო ველი"
            },
            deliveryInfo: {
                cost: "ამ რაიონში მიტანის ღირებულება შეადგენს"
            },
            agreement: {
                text: "გაგრძელებით თქვენ ეთანხმებით პერსონალური მონაცემების დამუშავებას და",
                userAgreement: "მომხმარებლის შეთანხმებას",
                and: "და",
                privacyPolicy: "კონფიდენციალურობის პოლიტიკას"
            }
        },
        modSelector: {
            outOfStock: "არ არის მარაგში"
        },
        variantSelector: {
            chooseOption: 'აირჩიეთ ვარიანტი'
        },
        notifications: {
            productStopped: 'დროებით მიუწვდომელია',
            maxQuantityExceeded: 'ამ პროდუქტისთვის შეკვეთაზე {max} ცალი ლიმიტია'
        }
    },
    ko: {
        common: {
            unknownError: '알 수 없는 오류'
        },
        actions: {
            button: '직원 호출',
            popupTitle: '직원 호출',
            popupSubmitButton: '전송',
            popupCloseButton: '닫기',
            notifSuccess: '요청이 전송되었습니다',
            notifFailed: '오류가 발생했습니다. 다시 시도해 주세요',
            notifError: '오류가 발생했습니다',
        },
        nav: {
            categories: '메뉴 카테고리',
            favorite: '즐겨찾기',
            search: '검색',
            allergens: '알레르기 유발 물질',
        },
        buttons: {
            addToCart: '장바구니에 추가'
        },
        search: {
            placeholder: "검색...",
            nothingFound: "검색 결과가 없습니다"
        },
        order: {
            title: "주문하기",
            success: {
                title: "완료",
                message: "주문이 성공적으로 접수되었습니다. 곧 연락드리겠습니다",
                orderNumber: "주문 번호"
            },
            error: {
                title: "오류",
                placement: "주문 접수 오류"
            },
            buttons: {
                return: '메뉴로 돌아가기',
                retry: '다시 시도',
                save: '메뉴를 휴대폰에 저장'
            }
        },
        cart: {
            all: "전체",
            title: "장바구니",
            empty: "장바구니가 비어있습니다",
            widget: "장바구니에",
            itemsCount: "개",
            openMenu: "메뉴 열기",
            unnamed: "이름 없음",
            notInCart: "아직 장바구니에 추가되지 않았습니다",
            askWaiter: "주문은 직원에게 요청해 주세요",
            buttons: {
                retry: "다시 시도",
                returnToMenu: "메뉴로 돌아가기",
                saveMenu: "메뉴를 휴대폰에 저장"
            }
        },
        filters: {
            allergens: '알레르기 유발 물질'
        },
        blocks: {
            recommendations: {
                title: "추천 메뉴",
                empty: "추천 메뉴가 없습니다"
            },
            favorites: {
                title: "즐겨찾는 메뉴",
                empty: "즐겨찾는 메뉴가 없습니다"
            },
            total: {
                sum: "금액",
                delivery: "배달비",
                deliveryCost: "배달비",
                total: "총액"
            }
        },
        footer: {
            address: "주소",
            contacts: "연락처",
            map: "지도",
            privacyPolicy: "개인정보 처리방침",
            termsOfUse: "이용약관"
        },
        docs: {
            privacyPolicy: '개인정보 처리방침',
            accept: '개인정보 처리방침 및 적용 가능한 데이터 보호 법률에 따라 내 개인 데이터 처리에 동의합니다.'
        },
        legal: {
            title: '법적 정보'
        },
        cartOrder: {
            placeOrder: "주문하기",
            closed: "레스토랑이 닫혔습니다",
            minOrder: "최소 주문 금액",
            minOrderMessage: "주문 금액이 최소 주문 금액보다 낮습니다. 주문을 완료하려면 다음 금액 이상의 메뉴를 장바구니에 추가해야 합니다",
            deliveryClosedMessage: "죄송합니다. 현재 배달 서비스가 운영되지 않습니다. 배달 서비스가 시작되는 즉시 주문을 처리하겠습니다.",
            openInMinutes: "배달 서비스 오픈까지",
            minutes: "분.",
            openAt: "배달 서비스 운영 시간:"
        },
        dmLabel: {
            text: "이 메뉴는 다음 플랫폼에서 제작되었습니다",
        },
        nutrition: {
            title: "영양 정보",
            weight: "1인분 중량",
            perServing: "1인분당",
            addToFavorites: "즐겨찾기에 추가",
            inFavorites: "즐겨찾기에 있음",
            calories: '칼로리',
            proteins: '단백질',
            fats: '지방',
            carbs: '탄수화물',
            gram: 'g'
        },
        allergens: {
            contains: '포함',
            Cereals: '곡물',
            Avocado: '아보카도',
            Peanuts: '땅콩',
            gluten: '글루텐',
            Mustard: '겨자',
            "Sulphur dioxide": '이산화황',
            Sesame: '참깨',
            Lupin: '루핀',
            Molluscs: '연체동물',
            Milk: '우유',
            Nuts: '견과류',
            Crustaceans: '갑각류',
            Fish: '생선',
            Celery: '셀러리',
            Soya: '대두',
            Eggs: '계란'
        },
        addToCart: {
            add: "추가하기",
            added: "추가됨"
        },
        details: {
            description: "설명",
            ingredients: "재료",
            weight: "중량",
            close: "닫기"
        },
        price: {
            from: "부터"
        },
        orderScreen: {
            title: "주문하기",
            buttons: {
                placeOrder: '주문하기'
            },
            deliveryType: {
                label: "주문을 어떻게 받으시겠습니까?",
                onsite: "매장에서",
                delivery: "배달",
                pickup: "포장"
            },
            fields: {
                deliveryRegion: "배달 지역",
                pickupPoint: "픽업 장소",
                name: "이름",
                phone: "전화번호",
                address: "배달 주소",
                comment: "주문 메모"
            },
            placeholders: {
                deliveryRegion: "어느 지역으로 배달해 드릴까요?",
                name: "이름을 입력해주세요",
                phone: "010-0000-0000",
                address: "어디로 배달해 드릴까요?",
                comment: "주문에 대한 메모"
            },
            errors: {
                deliveryRegion: "* 배달 지역을 선택해주세요",
                name: "* 이름을 입력해주세요",
                phone: {
                    empty: "* 연락 가능한 전화번호를 입력해주세요",
                    invalid: "* 전화번호가 올바르지 않은 것 같습니다. 최소 5자리 이상이어야 합니다"
                },
                address: "* 배달 주소를 입력해주세요",
                comment: "* 주문 메모를 추가해주세요",
                pickupPoint: "* 주문을 픽업할 장소를 선택해주세요",
                required: "* 필수 입력 항목"
            },
            deliveryInfo: {
                cost: "이 지역의 배달 비용은 다음과 같습니다"
            },
            agreement: {
                text: "계속 진행함으로써 개인정보 처리에 동의하고",
                userAgreement: "이용약관",
                and: "및",
                privacyPolicy: "개인정보 처리방침"
            }
        },
        modSelector: {
            outOfStock: "품절"
        },
        variantSelector: {
            chooseOption: '옵션을 선택하세요'
        },
        notifications: {
            productStopped: '일시적으로 사용할 수 없음',
            maxQuantityExceeded: '이 상품은 주문당 {max}개로 제한됩니다'
        }
    },
    de: {
        common: {
            unknownError: 'Unbekannter Fehler'
        },
        actions: {
            button: 'Personal rufen',
            popupTitle: 'Personal rufen',
            popupSubmitButton: 'Senden',
            popupCloseButton: 'Schließen',
            notifSuccess: 'Anfrage gesendet',
            notifFailed: 'Fehler. Bitte erneut versuchen',
            notifError: 'Es ist ein Fehler aufgetreten',
        },
        nav: {
            categories: 'Menükategorien',
            favorite: 'Favoriten',
            search: 'Suche',
            allergens: 'Allergene',
        },
        buttons: {
            addToCart: 'In den Warenkorb'
        },
        search: {
            placeholder: "Suche...",
            nothingFound: "Nichts gefunden"
        },
        order: {
            title: "Bestellung aufgeben",
            success: {
                title: "Fertig",
                message: "Bestellung erfolgreich aufgegeben. Wir rufen Sie in Kürze zurück",
                orderNumber: "Ihre Bestellnummer"
            },
            error: {
                title: "Fehler",
                placement: "Fehler beim Aufgeben der Bestellung"
            },
            buttons: {
                return: 'Zurück zum Menü',
                retry: 'Erneut versuchen',
                save: 'Menü auf dem Telefon speichern'
            }
        },
        cart: {
            all: "Alle",
            title: "Mein Warenkorb",
            empty: "Warenkorb ist leer",
            widget: "Im Warenkorb",
            itemsCount: "Gericht(e)",
            openMenu: "Menü öffnen",
            unnamed: "Ohne Name",
            notInCart: "noch nicht im Warenkorb",
            askWaiter: "Bitte bestellen Sie über den Kellner",
            buttons: {
                retry: "Erneut versuchen",
                returnToMenu: "Zurück zum Menü",
                saveMenu: "Menü auf dem Telefon speichern"
            }
        },
        filters: {
            allergens: 'Allergene'
        },
        blocks: {
            recommendations: {
                title: "Empfohlen",
                empty: "Keine Empfehlungen"
            },
            favorites: {
                title: "Ihre Lieblingsgerichte",
                empty: "Keine Lieblingsgerichte"
            },
            total: {
                sum: "Summe",
                delivery: "Lieferung",
                deliveryCost: "Lieferkosten",
                total: "Gesamt"
            }
        },
        footer: {
            address: "Adresse",
            contacts: "Kontakte",
            map: "Karte",
            privacyPolicy: "Datenschutzrichtlinie",
            termsOfUse: "Nutzungsbedingungen"
        },
        docs: {
            privacyPolicy: 'Datenschutzrichtlinie',
            accept: 'Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der Datenschutzrichtlinie und den geltenden Datenschutzgesetzen zu.'
        },
        legal: {
            title: 'Rechtliche Informationen'
        },
        cartOrder: {
            placeOrder: "Bestellen",
            closed: "Restaurant geschlossen",
            minOrder: "Mindestbestellwert",
            minOrderMessage: "Der Bestellbetrag liegt unter dem Minimum. Fügen Sie Artikel im Wert von mindestens",
            deliveryClosedMessage: "Leider ist der Lieferservice derzeit geschlossen. Wir nehmen Ihre Bestellung an und bearbeiten sie, sobald er geöffnet ist.",
            openInMinutes: "Lieferung öffnet in",
            minutes: "Min.",
            openAt: "Lieferung arbeitet von"
        },
        dmLabel: {
            text: "Dieses Menü wurde auf der Plattform erstellt"
        },
        nutrition: {
            title: "Nährwertangaben",
            weight: "Portionsgröße",
            perServing: "pro Portion",
            addToFavorites: "Zu Favoriten hinzufügen",
            inFavorites: "In Favoriten",
            calories: 'kcal',
            proteins: 'Eiweiß',
            fats: 'Fette',
            carbs: 'Kohlenhydrate',
            gram: 'g'
        },
        allergens: {
            contains: 'Enthält',
            Cereals: 'Getreide',
            Avocado: 'Avocado',
            Peanuts: 'Erdnüsse',
            gluten: 'Gluten',
            Mustard: 'Senf',
            "Sulphur dioxide": 'Schwefeldioxid',
            Sesame: 'Sesam',
            Lupin: 'Lupine',
            Molluscs: 'Weichtiere',
            Milk: 'Milch',
            Nuts: 'Nüsse',
            Crustaceans: 'Krebstiere',
            Fish: 'Fisch',
            Celery: 'Sellerie',
            Soya: 'Soja',
            Eggs: 'Eier'
        },
        addToCart: {
            add: "Hinzufügen",
            added: "Hinzugefügt"
        },
        details: {
            description: "Beschreibung",
            ingredients: "Zutaten",
            weight: "Gewicht",
            close: "Schließen"
        },
        price: {
            from: "ab"
        },
        orderScreen: {
            title: "Bestellung aufgeben",
            buttons: {
                placeOrder: 'Bestellen'
            },
            deliveryType: {
                label: "Wie möchten Sie Ihre Bestellung erhalten?",
                onsite: "Vor Ort",
                delivery: "Lieferung an Adresse",
                pickup: "Selbstabholung"
            },
            fields: {
                deliveryRegion: "Liefergebiet",
                pickupPoint: "Abholpunkt",
                name: "Name",
                phone: "Telefon",
                address: "Lieferadresse",
                comment: "Kommentar zur Bestellung"
            },
            placeholders: {
                deliveryRegion: "In welches Gebiet liefern?",
                name: "Wie dürfen wir Sie nennen?",
                phone: "+49 000 000 0000",
                address: "Wohin liefern?",
                comment: "Kommentar zur Bestellung"
            },
            errors: {
                deliveryRegion: "* Bitte Liefergebiet wählen",
                name: "* Bitte Namen angeben",
                phone: {
                    empty: "* Bitte Telefonnummer angeben",
                    invalid: "* Telefonnummer scheint falsch. Mindestens 5 Ziffern"
                },
                address: "* Bitte Lieferadresse angeben",
                comment: "* Bitte Kommentar zur Bestellung hinzufügen",
                pickupPoint: "* Bitte Abholort angeben",
                required: "* Pflichtfeld"
            },
            deliveryInfo: {
                cost: "Lieferkosten in dieses Gebiet betragen"
            },
            agreement: {
                text: "Mit Fortfahren stimmen Sie der Verarbeitung personenbezogener Daten zu und akzeptieren die",
                userAgreement: "Nutzervereinbarung",
                and: "und",
                privacyPolicy: "Datenschutzrichtlinie"
            }
        },
        modSelector: {
            outOfStock: "nicht vorrätig"
        },
        variantSelector: {
            chooseOption: 'Option wählen'
        },
        notifications: {
            productStopped: 'Vorübergehend nicht verfügbar',
            maxQuantityExceeded: 'Für dieses Produkt gilt ein Limit von {max} pro Bestellung'
        }
    },
    fr: {
        common: {
            unknownError: 'Erreur inconnue'
        },
        actions: {
            button: 'Appeler le personnel',
            popupTitle: 'Appeler le personnel',
            popupSubmitButton: 'Envoyer',
            popupCloseButton: 'Fermer',
            notifSuccess: 'Requête envoyée',
            notifFailed: 'Erreur. Veuillez réessayer',
            notifError: 'Une erreur est survenue',
        },
        nav: {
            categories: 'Catégories du menu',
            favorite: 'Favoris',
            search: 'Recherche',
            allergens: 'Allergènes',
        },
        buttons: {
            addToCart: 'Ajouter au panier'
        },
        search: {
            placeholder: "Recherche...",
            nothingFound: "Aucun résultat"
        },
        order: {
            title: "Passer commande",
            success: {
                title: "Terminé",
                message: "Commande passée avec succès. Nous vous rappellerons bientôt",
                orderNumber: "Numéro de commande"
            },
            error: {
                title: "Erreur",
                placement: "Erreur lors de la commande"
            },
            buttons: {
                return: 'Retour au menu',
                retry: 'Réessayer',
                save: 'Enregistrer le menu sur le téléphone'
            }
        },
        cart: {
            all: "Tous",
            title: "Mon panier",
            empty: "Panier vide",
            widget: "Dans le panier",
            itemsCount: "plat(s)",
            openMenu: "Ouvrir le menu",
            unnamed: "Sans nom",
            notInCart: "pas encore ajouté au panier",
            askWaiter: "Veuillez demander au serveur pour passer commande",
            buttons: {
                retry: "Réessayer",
                returnToMenu: "Retour au menu",
                saveMenu: "Enregistrer le menu sur le téléphone"
            }
        },
        filters: {
            allergens: 'Allergènes'
        },
        blocks: {
            recommendations: {
                title: "Recommandés",
                empty: "Aucune recommandation"
            },
            favorites: {
                title: "Vos plats favoris",
                empty: "Aucun plat favori"
            },
            total: {
                sum: "Montant",
                delivery: "Livraison",
                deliveryCost: "Frais de livraison",
                total: "Total"
            }
        },
        footer: {
            address: "Adresse",
            contacts: "Contacts",
            map: "Carte",
            privacyPolicy: "Politique de confidentialité",
            termsOfUse: "Conditions d'utilisation"
        },
        docs: {
            privacyPolicy: 'Politique de confidentialité',
            accept: 'Je consens au traitement de mes données personnelles conformément à la Politique de confidentialité et à la législation applicable sur la protection des données.'
        },
        legal: {
            title: 'Informations légales'
        },
        cartOrder: {
            placeOrder: "Passer commande",
            closed: "Restaurant fermé",
            minOrder: "Commande minimale",
            minOrderMessage: "Le montant de votre commande est inférieur au minimum. Pour commander, ajoutez des articles pour au moins",
            deliveryClosedMessage: "Le service de livraison est actuellement fermé. Nous accepterons votre commande et la traiterons dès son ouverture.",
            openInMinutes: "La livraison ouvre dans",
            minutes: "min.",
            openAt: "La livraison fonctionne de"
        },
        dmLabel: {
            text: "Ce menu est réalisé sur la plateforme"
        },
        nutrition: {
            title: "Valeurs nutritionnelles",
            weight: "Taille de portion",
            perServing: "par portion",
            addToFavorites: "Ajouter aux favoris",
            inFavorites: "Dans les favoris",
            calories: 'kcal',
            proteins: 'protéines',
            fats: 'graisses',
            carbs: 'glucides',
            gram: 'g'
        },
        allergens: {
            contains: 'Contient',
            Cereals: 'Céréales',
            Avocado: 'Avocat',
            Peanuts: 'Arachides',
            gluten: 'Gluten',
            Mustard: 'Moutarde',
            "Sulphur dioxide": 'Dioxyde de soufre',
            Sesame: 'Sésame',
            Lupin: 'Lupin',
            Molluscs: 'Mollusques',
            Milk: 'Lait',
            Nuts: 'Fruits à coque',
            Crustaceans: 'Crustacés',
            Fish: 'Poisson',
            Celery: 'Céleri',
            Soya: 'Soja',
            Eggs: 'Œufs'
        },
        addToCart: {
            add: "Ajouter",
            added: "Ajouté"
        },
        details: {
            description: "Description",
            ingredients: "Ingrédients",
            weight: "Poids",
            close: "Fermer"
        },
        price: {
            from: "à partir de"
        },
        orderScreen: {
            title: "Passer commande",
            buttons: {
                placeOrder: 'Passer commande'
            },
            deliveryType: {
                label: "Comment souhaitez-vous recevoir votre commande ?",
                onsite: "Sur place",
                delivery: "Livraison à l'adresse",
                pickup: "À emporter"
            },
            fields: {
                deliveryRegion: "Zone de livraison",
                pickupPoint: "Point de retrait",
                name: "Nom",
                phone: "Téléphone",
                address: "Adresse de livraison",
                comment: "Commentaire de commande"
            },
            placeholders: {
                deliveryRegion: "Dans quelle zone livrer ?",
                name: "Comment devons-nous vous appeler ?",
                phone: "+33 0 00 00 00 00",
                address: "Où livrer ?",
                comment: "Commentaire de commande"
            },
            errors: {
                deliveryRegion: "* Veuillez sélectionner une zone de livraison",
                name: "* Veuillez indiquer votre nom",
                phone: {
                    empty: "* Merci de fournir un téléphone de contact",
                    invalid: "* Le numéro semble incorrect. Au moins 5 chiffres"
                },
                address: "* Merci d’indiquer l’adresse de livraison",
                comment: "* Merci d’ajouter un commentaire à la commande",
                pickupPoint: "* Merci de préciser le point de retrait",
                required: "* Champ obligatoire"
            },
            deliveryInfo: {
                cost: "Le coût de livraison pour cette zone est"
            },
            agreement: {
                text: "En continuant, vous acceptez le traitement des données personnelles et acceptez",
                userAgreement: "le Contrat Utilisateur",
                and: "et",
                privacyPolicy: "la Politique de confidentialité"
            }
        },
        modSelector: {
            outOfStock: "en rupture"
        },
        variantSelector: {
            chooseOption: 'Choisissez une option'
        },
        notifications: {
            productStopped: 'Temporairement indisponible',
            maxQuantityExceeded: 'Une limite de {max} par commande s’applique à ce produit'
        }
    },
    it: {
        common: {
            unknownError: 'Errore sconosciuto'
        },
        actions: {
            button: 'Chiama il personale',
            popupTitle: 'Chiama il personale',
            popupSubmitButton: 'Invia',
            popupCloseButton: 'Chiudi',
            notifSuccess: 'Richiesta inviata',
            notifFailed: 'Errore. Riprova',
            notifError: 'Si è verificato un errore',
        },
        nav: {
            categories: 'Categorie del menu',
            favorite: 'Preferiti',
            search: 'Cerca',
            allergens: 'Allergeni',
        },
        buttons: {
            addToCart: 'Aggiungi al carrello'
        },
        search: {
            placeholder: "Cerca...",
            nothingFound: "Nessun risultato"
        },
        order: {
            title: "Effettua ordine",
            success: {
                title: "Fatto",
                message: "Ordine effettuato con successo. Ti richiameremo a breve",
                orderNumber: "Numero dell'ordine"
            },
            error: {
                title: "Errore",
                placement: "Errore durante l'ordine"
            },
            buttons: {
                return: 'Torna al menu',
                retry: 'Riprova',
                save: 'Salva il menu sul telefono'
            }
        },
        cart: {
            all: "Tutti",
            title: "Il mio carrello",
            empty: "Il carrello è vuoto",
            widget: "Nel carrello",
            itemsCount: "piatto/i",
            openMenu: "Apri menu",
            unnamed: "Senza nome",
            notInCart: "non ancora aggiunto al carrello",
            askWaiter: "Per ordinare, rivolgiti al cameriere",
            buttons: {
                retry: "Riprova",
                returnToMenu: "Torna al menu",
                saveMenu: "Salva il menu sul telefono"
            }
        },
        filters: {
            allergens: 'Allergeni'
        },
        blocks: {
            recommendations: {
                title: "Consigliati",
                empty: "Nessun consiglio"
            },
            favorites: {
                title: "I tuoi piatti preferiti",
                empty: "Nessun piatto preferito"
            },
            total: {
                sum: "Totale parziale",
                delivery: "Consegna",
                deliveryCost: "Costo di consegna",
                total: "Totale"
            }
        },
        footer: {
            address: "Indirizzo",
            contacts: "Contatti",
            map: "Mappa",
            privacyPolicy: "Informativa sulla privacy",
            termsOfUse: "Termini di utilizzo"
        },
        docs: {
            privacyPolicy: 'Informativa sulla privacy',
            accept: 'Acconsento al trattamento dei miei dati personali in conformità con l\'Informativa sulla privacy e la legislazione applicabile sulla protezione dei dati.'
        },
        legal: {
            title: 'Informazioni legali'
        },
        cartOrder: {
            placeOrder: "Effettua ordine",
            closed: "Ristorante chiuso",
            minOrder: "Ordine minimo",
            minOrderMessage: "L'importo dell'ordine è inferiore al minimo. Aggiungi articoli per almeno",
            deliveryClosedMessage: "Il servizio di consegna è attualmente chiuso. Accetteremo il tuo ordine e lo elaboreremo appena riapre.",
            openInMinutes: "La consegna aprirà tra",
            minutes: "min.",
            openAt: "La consegna opera dalle"
        },
        dmLabel: {
            text: "Questo menu è realizzato sulla piattaforma"
        },
        nutrition: {
            title: "Valori nutrizionali",
            weight: "Dimensione porzione",
            perServing: "per porzione",
            addToFavorites: "Aggiungi ai preferiti",
            inFavorites: "Nei preferiti",
            calories: 'kcal',
            proteins: 'proteine',
            fats: 'grassi',
            carbs: 'carboidrati',
            gram: 'g'
        },
        allergens: {
            contains: 'Contiene',
            Cereals: 'Cereali',
            Avocado: 'Avocado',
            Peanuts: 'Arachidi',
            gluten: 'Glutine',
            Mustard: 'Senape',
            "Sulphur dioxide": 'Anidride solforosa',
            Sesame: 'Sesamo',
            Lupin: 'Lupino',
            Molluscs: 'Molluschi',
            Milk: 'Latte',
            Nuts: 'Frutta a guscio',
            Crustaceans: 'Crostacei',
            Fish: 'Pesce',
            Celery: 'Sedano',
            Soya: 'Soia',
            Eggs: 'Uova'
        },
        addToCart: {
            add: "Aggiungi",
            added: "Aggiunto"
        },
        details: {
            description: "Descrizione",
            ingredients: "Ingredienti",
            weight: "Peso",
            close: "Chiudi"
        },
        price: {
            from: "da"
        },
        orderScreen: {
            title: "Effettua ordine",
            buttons: {
                placeOrder: 'Effettua ordine'
            },
            deliveryType: {
                label: "Come desideri ricevere l'ordine?",
                onsite: "In loco",
                delivery: "Consegna all'indirizzo",
                pickup: "Ritiro"
            },
            fields: {
                deliveryRegion: "Zona di consegna",
                pickupPoint: "Punto di ritiro",
                name: "Nome",
                phone: "Telefono",
                address: "Indirizzo di consegna",
                comment: "Nota per l'ordine"
            },
            placeholders: {
                deliveryRegion: "In quale zona consegnare?",
                name: "Come possiamo chiamarti?",
                phone: "+39 000 000 0000",
                address: "Dove consegnare?",
                comment: "Nota per l'ordine"
            },
            errors: {
                deliveryRegion: "* Seleziona la zona di consegna",
                name: "* Inserisci il nome",
                phone: {
                    empty: "* Fornisci un telefono di contatto",
                    invalid: "* Numero non valido. Almeno 5 cifre"
                },
                address: "* Inserisci l'indirizzo di consegna",
                comment: "* Aggiungi una nota all'ordine",
                pickupPoint: "* Specifica dove ritirare l'ordine",
                required: "* Campo obbligatorio"
            },
            deliveryInfo: {
                cost: "Il costo di consegna per questa zona è"
            },
            agreement: {
                text: "Continuando accetti il trattamento dei dati personali e l'",
                userAgreement: "Accordo con l'utente",
                and: "e",
                privacyPolicy: "Informativa sulla privacy"
            }
        },
        modSelector: {
            outOfStock: "non disponibile"
        },
        variantSelector: {
            chooseOption: 'Scegli un\'opzione'
        },
        notifications: {
            productStopped: 'Temporaneamente non disponibile',
            maxQuantityExceeded: 'Per questo prodotto è previsto un limite di {max} per ordine'
        }
    },
    hi: {
        common: {
            unknownError: 'अज्ञात त्रुटि'
        },
        actions: {
            button: 'स्टाफ को बुलाएँ',
            popupTitle: 'स्टाफ को बुलाएँ',
            popupSubmitButton: 'भेजें',
            popupCloseButton: 'बंद करें',
            notifSuccess: 'अनुरोध भेजा गया',
            notifFailed: 'त्रुटि। कृपया पुनः प्रयास करें',
            notifError: 'एक त्रुटि हुई',
        },
        nav: {
            categories: 'मेनू श्रेणियाँ',
            favorite: 'पसंदीदा',
            search: 'खोज',
            allergens: 'एलर्जेंस',
        },
        buttons: {
            addToCart: 'कार्ट में जोड़ें'
        },
        search: {
            placeholder: "खोजें...",
            nothingFound: "कुछ नहीं मिला"
        },
        order: {
            title: "ऑर्डर करें",
            success: {
                title: "पूरा",
                message: "ऑर्डर सफलतापूर्वक किया गया। हम जल्द ही आपसे संपर्क करेंगे",
                orderNumber: "आपका ऑर्डर नंबर"
            },
            error: {
                title: "त्रुटि",
                placement: "ऑर्डर करने में त्रुटि"
            },
            buttons: {
                return: 'मेनू पर वापस जाएँ',
                retry: 'पुनः प्रयास करें',
                save: 'मेनू फोन में सेव करें'
            }
        },
        cart: {
            all: "सभी",
            title: "मेरा कार्ट",
            empty: "कार्ट खाली है",
            widget: "कार्ट में",
            itemsCount: "डिश(ें)",
            openMenu: "मेनू खोलें",
            unnamed: "बिना नाम",
            notInCart: "अभी कार्ट में नहीं जोड़ा",
            askWaiter: "कृपया ऑर्डर के लिए वेटर से कहें",
            buttons: {
                retry: "पुनः प्रयास करें",
                returnToMenu: "मेनू पर वापस जाएँ",
                saveMenu: "मेनू फोन में सेव करें"
            }
        },
        filters: {
            allergens: 'एलर्जेंस'
        },
        blocks: {
            recommendations: {
                title: "अनुशंसित",
                empty: "कोई अनुशंसा नहीं"
            },
            favorites: {
                title: "आपके पसंदीदा व्यंजन",
                empty: "कोई पसंदीदा व्यंजन नहीं"
            },
            total: {
                sum: "राशि",
                delivery: "डिलीवरी",
                deliveryCost: "डिलीवरी शुल्क",
                total: "कुल"
            }
        },
        footer: {
            address: "पता",
            contacts: "संपर्क",
            map: "नक्शा",
            privacyPolicy: "गोपनीयता नीति",
            termsOfUse: "उपयोग की शर्तें"
        },
        docs: {
            privacyPolicy: 'गोपनीयता नीति',
            accept: 'मैं गोपनीयता नीति और लागू डेटा सुरक्षा कानून के अनुसार अपने व्यक्तिगत डेटा के प्रसंस्करण के लिए सहमति देता हूं।'
        },
        legal: {
            title: 'कानूनी जानकारी'
        },
        cartOrder: {
            placeOrder: "ऑर्डर करें",
            closed: "रेस्टोरेंट बंद है",
            minOrder: "न्यूनतम ऑर्डर",
            minOrderMessage: "आपका ऑर्डर न्यूनतम राशि से कम है। ऑर्डर करने के लिए कम से कम इतना जोड़ें",
            deliveryClosedMessage: "दुर्भाग्य से डिलीवरी सेवा बंद है। हम आपका ऑर्डर स्वीकार करेंगे और खुलते ही प्रोसेस करेंगे।",
            openInMinutes: "डिलीवरी शुरू होने में",
            minutes: "मिन.",
            openAt: "डिलीवरी समय"
        },
        dmLabel: {
            text: "यह मेनू इस प्लेटफ़ॉर्म पर बनाया गया है"
        },
        nutrition: {
            title: "पोषण जानकारी",
            weight: "सर्विंग साइज",
            perServing: "प्रति सर्विंग",
            addToFavorites: "फेवरेट में जोड़ें",
            inFavorites: "फेवरेट में",
            calories: 'कैल',
            proteins: 'प्रोटीन',
            fats: 'वसा',
            carbs: 'कार्ब्स',
            gram: 'ग्राम'
        },
        allergens: {
            contains: 'शामिल है',
            Cereals: 'अनाज',
            Avocado: 'एवोकाडो',
            Peanuts: 'मूंगफली',
            gluten: 'ग्लूटेन',
            Mustard: 'सरसों',
            "Sulphur dioxide": 'सल्फर डाइऑक्साइड',
            Sesame: 'तिल',
            Lupin: 'लुपिन',
            Molluscs: 'शंख-घोंघे',
            Milk: 'दूध',
            Nuts: 'मेवे',
            Crustaceans: 'क्रस्टेशियंस',
            Fish: 'मछली',
            Celery: 'सेलेरी',
            Soya: 'सोया',
            Eggs: 'अंडे'
        },
        addToCart: {
            add: "जोड़ें",
            added: "जोड़ा गया"
        },
        details: {
            description: "विवरण",
            ingredients: "सामग्री",
            weight: "वजन",
            close: "बंद करें"
        },
        price: {
            from: "से"
        },
        orderScreen: {
            title: "ऑर्डर करें",
            buttons: {
                placeOrder: 'ऑर्डर करें'
            },
            deliveryType: {
                label: "आप ऑर्डर कैसे प्राप्त करना चाहते हैं?",
                onsite: "रेस्टोरेंट में",
                delivery: "पते पर डिलीवरी",
                pickup: "पिकअप"
            },
            fields: {
                deliveryRegion: "डिलीवरी क्षेत्र",
                pickupPoint: "पिकअप पॉइंट",
                name: "नाम",
                phone: "फोन",
                address: "डिलीवरी पता",
                comment: "ऑर्डर टिप्पणी"
            },
            placeholders: {
                deliveryRegion: "किस क्षेत्र में डिलीवर करें?",
                name: "आपको क्या बुलाएँ?",
                phone: "+91 00000 00000",
                address: "कहाँ डिलीवर करें?",
                comment: "ऑर्डर टिप्पणी"
            },
            errors: {
                deliveryRegion: "* कृपया डिलीवरी क्षेत्र चुनें",
                name: "* कृपया नाम दर्ज करें",
                phone: {
                    empty: "* संपर्क फोन दें",
                    invalid: "* नंबर गलत लगता है। कम से कम 5 अंक"
                },
                address: "* कृपया डिलीवरी पता दर्ज करें",
                comment: "* कृपया ऑर्डर में टिप्पणी जोड़ें",
                pickupPoint: "* कृपया बताएं कहाँ से लेना है",
                required: "* अनिवार्य फ़ील्ड"
            },
            deliveryInfo: {
                cost: "इस क्षेत्र के लिए डिलीवरी लागत"
            },
            agreement: {
                text: "आगे बढ़कर, आप व्यक्तिगत डेटा के प्रसंस्करण के लिए सहमति देते हैं और सहमत हैं",
                userAgreement: "उपयोगकर्ता अनुबंध",
                and: "और",
                privacyPolicy: "गोपनीयता नीति"
            }
        },
        modSelector: {
            outOfStock: "स्टॉक में नहीं"
        },
        variantSelector: {
            chooseOption: 'विकल्प चुनें'
        },
        notifications: {
            productStopped: 'अस्थायी रूप से उपलब्ध नहीं',
            maxQuantityExceeded: 'इस उत्पाद के लिए प्रति ऑर्डर {max} की सीमा है'
        }
    },
    bn: {
        common: {
            unknownError: 'অজানা ত্রুটি'
        },
        actions: {
            button: 'স্টাফ ডাকুন',
            popupTitle: 'স্টাফ ডাকুন',
            popupSubmitButton: 'পাঠান',
            popupCloseButton: 'বন্ধ করুন',
            notifSuccess: 'অনুরোধ পাঠানো হয়েছে',
            notifFailed: 'ত্রুটি। অনুগ্রহ করে আবার চেষ্টা করুন',
            notifError: 'একটি ত্রুটি ঘটেছে',
        },
        nav: {
            categories: 'মেনু বিভাগ',
            favorite: 'পছন্দ',
            search: 'খুঁজুন',
            allergens: 'অ্যালার্জেন',
        },
        buttons: {
            addToCart: 'কার্টে যোগ করুন'
        },
        search: {
            placeholder: "খুঁজুন...",
            nothingFound: "কিছু পাওয়া যায়নি"
        },
        order: {
            title: "অর্ডার করুন",
            success: {
                title: "সম্পন্ন",
                message: "অর্ডার সফলভাবে করা হয়েছে। আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব",
                orderNumber: "আপনার অর্ডার নম্বর"
            },
            error: {
                title: "ত্রুটি",
                placement: "অর্ডার করার সময় ত্রুটি"
            },
            buttons: {
                return: 'মেনুতে ফিরে যান',
                retry: 'পুনরায় চেষ্টা করুন',
                save: 'মেনু ফোনে সংরক্ষণ করুন'
            }
        },
        cart: {
            all: "সব",
            title: "আমার কার্ট",
            empty: "কার্ট খালি",
            widget: "কার্টে",
            itemsCount: "আইটেম",
            openMenu: "মেনু খুলুন",
            unnamed: "নামহীন",
            notInCart: "এখনও কার্টে যোগ করা হয়নি",
            askWaiter: "অর্ডার করতে অনুগ্রহ করে ওয়েটারকে বলুন",
            buttons: {
                retry: "পুনরায় চেষ্টা করুন",
                returnToMenu: "মেনুতে ফিরে যান",
                saveMenu: "মেনু ফোনে সংরক্ষণ করুন"
            }
        },
        filters: {
            allergens: 'অ্যালার্জেন'
        },
        blocks: {
            recommendations: {
                title: "সুপারিশকৃত",
                empty: "কোনো সুপারিশ নেই"
            },
            favorites: {
                title: "আপনার প্রিয় খাবার",
                empty: "কোনো প্রিয় খাবার নেই"
            },
            total: {
                sum: "মোট",
                delivery: "ডেলিভারি",
                deliveryCost: "ডেলিভারি খরচ",
                total: "সর্বমোট"
            }
        },
        footer: {
            address: "ঠিকানা",
            contacts: "যোগাযোগ",
            map: "মানচিত্র",
            privacyPolicy: "গোপনীয়তা নীতি",
            termsOfUse: "ব্যবহারের শর্তাবলী"
        },
        docs: {
            privacyPolicy: 'গোপনীয়তা নীতি',
            accept: 'আমি গোপনীয়তা নীতি এবং প্রযোজ্য ডেটা সুরক্ষা আইন অনুসারে আমার ব্যক্তিগত ডেটা প্রক্রিয়াকরণে সম্মতি দিচ্ছি।'
        },
        legal: {
            title: 'আইনি তথ্য'
        },
        cartOrder: {
            placeOrder: "অর্ডার করুন",
            closed: "রেস্তোরাঁ বন্ধ",
            minOrder: "সর্বনিম্ন অর্ডার",
            minOrderMessage: "আপনার অর্ডারের পরিমাণ সর্বনিম্নের চেয়ে কম। অর্ডার করতে আপনাকে কার্টে কমপক্ষে এই পরিমাণের আইটেম যোগ করতে হবে",
            deliveryClosedMessage: "দুঃখিত, বর্তমানে ডেলিভারি পরিষেবা বন্ধ রয়েছে। আমরা আপনার অর্ডার গ্রহণ করব এবং এটি খোলার সাথে সাথেই প্রক্রিয়া করব।",
            openInMinutes: "ডেলিভারি খুলবে",
            minutes: "মিনিটে",
            openAt: "ডেলিভারি কাজ করে"
        },
        dmLabel: {
            text: "এই মেনু প্ল্যাটফর্মে তৈরি করা হয়েছে",
        },
        nutrition: {
            title: "পুষ্টির তথ্য",
            weight: "সার্ভিং সাইজ",
            perServing: "প্রতি সার্ভিং",
            addToFavorites: "পছন্দে যোগ করুন",
            inFavorites: "পছন্দে আছে",
            calories: 'ক্যালোরি',
            proteins: 'প্রোটিন',
            fats: 'চর্বি',
            carbs: 'কার্বোহাইড্রেট',
            gram: 'গ্রাম'
        },
        allergens: {
            contains: 'ধারণ করে',
            Cereals: 'শস্য',
            Avocado: 'আভোকাডো',
            Peanuts: 'চিনাবাদাম',
            gluten: 'গ্লুটেন',
            Mustard: 'সরিষা',
            "Sulphur dioxide": 'সালফার ডাই অক্সাইড',
            Sesame: 'তিল',
            Lupin: 'লুপিন',
            Molluscs: 'মলাস্ক',
            Milk: 'দুধ',
            Nuts: 'বাদাম',
            Crustaceans: 'কর্স্টেসিয়ান',
            Fish: 'মাছ',
            Celery: 'সেলারি',
            Soya: 'সয়াবিন',
            Eggs: 'ডিম'
        },
        addToCart: {
            add: "যোগ করুন",
            added: "যোগ করা হয়েছে"
        },
        details: {
            description: "বিবরণ",
            ingredients: "উপাদান",
            weight: "ওজন",
            close: "বন্ধ করুন"
        },
        price: {
            from: "থেকে"
        },
        orderScreen: {
            title: "অর্ডার করুন",
            buttons: {
                placeOrder: 'অর্ডার করুন'
            },
            deliveryType: {
                label: "আপনি কীভাবে অর্ডার পেতে চান?",
                onsite: "রেস্তোরাঁয়",
                delivery: "ঠিকানায় ডেলিভারি",
                pickup: "পিকআপ"
            },
            fields: {
                deliveryRegion: "ডেলিভারি এলাকা",
                pickupPoint: "পিকআপ পয়েন্ট",
                name: "নাম",
                phone: "ফোন",
                address: "ডেলিভারি ঠিকানা",
                comment: "অর্ডার মন্তব্য"
            },
            placeholders: {
                deliveryRegion: "কোন এলাকায় ডেলিভারি করতে হবে?",
                name: "আমরা আপনাকে কী বলে ডাকব?",
                phone: "+880 0000 000000",
                address: "কোথায় ডেলিভারি করতে হবে?",
                comment: "অর্ডার মন্তব্য"
            },
            errors: {
                deliveryRegion: "* অনুগ্রহ করে ডেলিভারি এলাকা নির্বাচন করুন",
                name: "* অনুগ্রহ করে নাম লিখুন",
                phone: {
                    empty: "* যোগাযোগের জন্য ফোন নম্বর দিন",
                    invalid: "* ফোন নম্বরটি সঠিক বলে মনে হচ্ছে না। কমপক্ষে ৫টি সংখ্যা থাকতে হবে"
                },
                address: "* অনুগ্রহ করে ডেলিভারি ঠিকানা দিন",
                comment: "* অনুগ্রহ করে অর্ডারে মন্তব্য যোগ করুন",
                pickupPoint: "* অনুগ্রহ করে নির্দেশ করুন আপনি কোথা থেকে অর্ডার নিতে চান",
                required: "* আবশ্যক ক্ষেত্র"
            },
            deliveryInfo: {
                cost: "এই এলাকায় ডেলিভারি খরচ হবে"
            },
            agreement: {
                text: "চালিয়ে যাওয়ার মাধ্যমে, আপনি ব্যক্তিগত ডেটা প্রক্রিয়াকরণে সম্মতি দিচ্ছেন এবং সম্মত হচ্ছেন",
                userAgreement: "ব্যবহারকারী চুক্তি",
                and: "এবং",
                privacyPolicy: "গোপনীয়তা নীতির"
            }
        },
        modSelector: {
            outOfStock: "স্টকে নেই"
        },
        variantSelector: {
            chooseOption: 'বিকল্প নির্বাচন করুন'
        },
        notifications: {
            productStopped: 'সাময়িকভাবে অনুপলব্ধ',
            maxQuantityExceeded: 'এই পণ্যের জন্য প্রতি অর্ডারে {max} টির সীমা রয়েছে'
        }
    },
    id: {
        common: {
            unknownError: 'Kesalahan tidak diketahui'
        },
        actions: {
            button: 'Panggil staf',
            popupTitle: 'Panggil staf',
            popupSubmitButton: 'Kirim',
            popupCloseButton: 'Tutup',
            notifSuccess: 'Permintaan terkirim',
            notifFailed: 'Kesalahan. Silakan coba lagi',
            notifError: 'Terjadi kesalahan',
        },
        nav: {
            categories: 'Kategori menu',
            favorite: 'Favorit',
            search: 'Cari',
            allergens: 'Alergen',
        },
        buttons: {
            addToCart: 'Tambah ke Keranjang'
        },
        search: {
            placeholder: "Cari...",
            nothingFound: "Tidak ada yang ditemukan"
        },
        order: {
            title: "Pesan",
            success: {
                title: "Selesai",
                message: "Pesanan berhasil dibuat. Kami akan menghubungi Anda segera",
                orderNumber: "Nomor pesanan Anda"
            },
            error: {
                title: "Kesalahan",
                placement: "Kesalahan saat memesan"
            },
            buttons: {
                return: 'Kembali ke menu',
                retry: 'Coba lagi',
                save: 'Simpan menu ke telepon'
            }
        },
        cart: {
            all: "Semua",
            title: "Keranjang Saya",
            empty: "Keranjang kosong",
            widget: "Di Keranjang",
            itemsCount: "item",
            openMenu: "Buka Menu",
            unnamed: "Tanpa nama",
            notInCart: "belum ditambahkan ke keranjang",
            askWaiter: "Silakan minta pelayan untuk memesan",
            buttons: {
                retry: "Coba Lagi",
                returnToMenu: "Kembali ke Menu",
                saveMenu: "Simpan Menu ke Telepon"
            }
        },
        filters: {
            allergens: 'Alergen'
        },
        blocks: {
            recommendations: {
                title: "Direkomendasikan",
                empty: "Tidak ada rekomendasi"
            },
            favorites: {
                title: "Hidangan Favorit Anda",
                empty: "Tidak ada hidangan favorit"
            },
            total: {
                sum: "Jumlah",
                delivery: "Pengiriman",
                deliveryCost: "Biaya pengiriman",
                total: "Total"
            }
        },
        footer: {
            address: "Alamat",
            contacts: "Kontak",
            map: "Peta",
            privacyPolicy: "Kebijakan Privasi",
            termsOfUse: "Syarat Penggunaan"
        },
        docs: {
            privacyPolicy: 'Kebijakan Privasi',
            accept: 'Saya menyetujui pemrosesan data pribadi saya sesuai dengan Kebijakan Privasi dan peraturan perlindungan data yang berlaku.'
        },
        legal: {
            title: 'Informasi hukum'
        },
        cartOrder: {
            placeOrder: "Pesan",
            closed: "Restoran tutup",
            minOrder: "Pesanan minimum",
            minOrderMessage: "Jumlah pesanan Anda di bawah minimum. Untuk memesan, Anda perlu menambahkan item senilai setidaknya",
            deliveryClosedMessage: "Sayangnya, layanan pengiriman saat ini tutup. Kami akan menerima pesanan Anda dan memprosesnya segera setelah layanan dibuka.",
            openInMinutes: "Pengiriman akan dibuka dalam",
            minutes: "menit",
            openAt: "Layanan pengiriman beroperasi dari"
        },
        dmLabel: {
            text: "Menu ini dibuat di platform",
        },
        nutrition: {
            title: "Informasi Nutrisi",
            weight: "Ukuran porsi",
            perServing: "per porsi",
            addToFavorites: "Tambah ke favorit",
            inFavorites: "Di favorit",
            calories: 'kkal',
            proteins: 'protein',
            fats: 'lemak',
            carbs: 'karbohidrat',
            gram: 'g'
        },
        allergens: {
            contains: 'Mengandung',
            Cereals: 'Sereal',
            Avocado: 'Alpukat',
            Peanuts: 'Kacang tanah',
            gluten: 'Gluten',
            Mustard: 'Mustard',
            "Sulphur dioxide": 'Sulfur dioksida',
            Sesame: 'Wijen',
            Lupin: 'Lupin',
            Molluscs: 'Moluska',
            Milk: 'Susu',
            Nuts: 'Kacang-kacangan',
            Crustaceans: 'Krustasea',
            Fish: 'Ikan',
            Celery: 'Seledri',
            Soya: 'Kedelai',
            Eggs: 'Telur'
        },
        addToCart: {
            add: "Tambah",
            added: "Ditambahkan"
        },
        details: {
            description: "Deskripsi",
            ingredients: "Bahan",
            weight: "Berat",
            close: "Tutup"
        },
        price: {
            from: "dari"
        },
        orderScreen: {
            title: "Pesan",
            buttons: {
                placeOrder: 'Pesan'
            },
            deliveryType: {
                label: "Bagaimana Anda ingin menerima pesanan?",
                onsite: "Di restoran",
                delivery: "Pengiriman ke alamat",
                pickup: "Ambil sendiri"
            },
            fields: {
                deliveryRegion: "Wilayah pengiriman",
                pickupPoint: "Titik pengambilan",
                name: "Nama",
                phone: "Telepon",
                address: "Alamat pengiriman",
                comment: "Komentar pesanan"
            },
            placeholders: {
                deliveryRegion: "Ke wilayah mana untuk dikirim?",
                name: "Apa yang harus kami panggil Anda?",
                phone: "+62 000 000 0000",
                address: "Kemana untuk dikirim?",
                comment: "Komentar pesanan"
            },
            errors: {
                deliveryRegion: "* Silakan pilih wilayah pengiriman",
                name: "* Silakan masukkan nama Anda",
                phone: {
                    empty: "* Berikan nomor telepon kontak",
                    invalid: "* Nomor telepon tampaknya salah. Harus memiliki setidaknya 5 digit"
                },
                address: "* Silakan berikan alamat pengiriman",
                comment: "* Silakan tambahkan komentar ke pesanan Anda",
                pickupPoint: "* Silakan tentukan di mana Anda ingin mengambil pesanan",
                required: "* Bidang wajib"
            },
            deliveryInfo: {
                cost: "Biaya pengiriman ke wilayah ini adalah"
            },
            agreement: {
                text: "Dengan melanjutkan, Anda menyetujui pemrosesan data pribadi dan menyetujui",
                userAgreement: "Perjanjian Pengguna",
                and: "dan",
                privacyPolicy: "Kebijakan Privasi"
            }
        },
        modSelector: {
            outOfStock: "stok habis"
        },
        variantSelector: {
            chooseOption: 'Pilih opsi'
        },
        notifications: {
            productStopped: 'Sementara tidak tersedia',
            maxQuantityExceeded: 'Ada batas {max} item per pesanan untuk produk ini'
        }
    },
    ms: {
        common: {
            unknownError: 'Ralat tidak diketahui'
        },
        actions: {
            button: 'Panggil kakitangan',
            popupTitle: 'Panggil kakitangan',
            popupSubmitButton: 'Hantar',
            popupCloseButton: 'Tutup',
            notifSuccess: 'Permintaan dihantar',
            notifFailed: 'Ralat. Sila cuba lagi',
            notifError: 'Ralat telah berlaku',
        },
        nav: {
            categories: 'Kategori menu',
            favorite: 'Kegemaran',
            search: 'Cari',
            allergens: 'Alergen',
        },
        buttons: {
            addToCart: 'Tambah ke Troli'
        },
        search: {
            placeholder: "Cari...",
            nothingFound: "Tiada hasil ditemui"
        },
        order: {
            title: "Buat Pesanan",
            success: {
                title: "Selesai",
                message: "Pesanan berjaya dibuat. Kami akan menghubungi anda tidak lama lagi",
                orderNumber: "Nombor pesanan anda"
            },
            error: {
                title: "Ralat",
                placement: "Ralat semasa membuat pesanan"
            },
            buttons: {
                return: 'Kembali ke menu',
                retry: 'Cuba lagi',
                save: 'Simpan menu ke telefon'
            }
        },
        cart: {
            all: "Semua",
            title: "Troli Saya",
            empty: "Troli kosong",
            widget: "Dalam Troli",
            itemsCount: "item",
            openMenu: "Buka Menu",
            unnamed: "Tanpa nama",
            notInCart: "belum ditambah ke troli",
            askWaiter: "Sila minta pelayan untuk membuat pesanan",
            buttons: {
                retry: "Cuba Lagi",
                returnToMenu: "Kembali ke Menu",
                saveMenu: "Simpan Menu ke Telefon"
            }
        },
        filters: {
            allergens: 'Alergen'
        },
        blocks: {
            recommendations: {
                title: "Disyorkan",
                empty: "Tiada cadangan"
            },
            favorites: {
                title: "Hidangan Kegemaran Anda",
                empty: "Tiada hidangan kegemaran"
            },
            total: {
                sum: "Jumlah",
                delivery: "Penghantaran",
                deliveryCost: "Kos penghantaran",
                total: "Jumlah"
            }
        },
        footer: {
            address: "Alamat",
            contacts: "Hubungan",
            map: "Peta",
            privacyPolicy: "Dasar Privasi",
            termsOfUse: "Terma Penggunaan"
        },
        docs: {
            privacyPolicy: 'Dasar Privasi',
            accept: 'Saya bersetuju dengan pemprosesan data peribadi saya mengikut Dasar Privasi dan perundangan perlindungan data yang berkenaan.'
        },
        legal: {
            title: 'Maklumat undang-undang'
        },
        cartOrder: {
            placeOrder: "Buat Pesanan",
            closed: "Restoran ditutup",
            minOrder: "Pesanan minimum",
            minOrderMessage: "Jumlah pesanan anda adalah di bawah minimum. Untuk membuat pesanan, anda perlu menambah item bernilai sekurang-kurangnya",
            deliveryClosedMessage: "Malangnya, perkhidmatan penghantaran kini ditutup. Kami akan menerima pesanan anda dan memprosesnya sebaik sahaja ia dibuka.",
            openInMinutes: "Penghantaran akan dibuka dalam",
            minutes: "minit",
            openAt: "Perkhidmatan penghantaran beroperasi dari"
        },
        dmLabel: {
            text: "Menu ini dibuat di platform",
        },
        nutrition: {
            title: "Maklumat Pemakanan",
            weight: "Saiz hidangan",
            perServing: "per hidangan",
            addToFavorites: "Tambah ke kegemaran",
            inFavorites: "Dalam kegemaran",
            calories: 'kkal',
            proteins: 'protein',
            fats: 'lemak',
            carbs: 'karbohidrat',
            gram: 'g'
        },
        allergens: {
            contains: 'Mengandungi',
            Cereals: 'Bijirin',
            Avocado: 'Avokado',
            Peanuts: 'Kacang tanah',
            gluten: 'Gluten',
            Mustard: 'Mustard',
            "Sulphur dioxide": 'Sulfur dioksida',
            Sesame: 'Bijan',
            Lupin: 'Lupin',
            Molluscs: 'Moluska',
            Milk: 'Susu',
            Nuts: 'Kacang',
            Crustaceans: 'Krustasea',
            Fish: 'Ikan',
            Celery: 'Saderi',
            Soya: 'Soya',
            Eggs: 'Telur'
        },
        addToCart: {
            add: "Tambah",
            added: "Ditambah"
        },
        details: {
            description: "Penerangan",
            ingredients: "Bahan",
            weight: "Berat",
            close: "Tutup"
        },
        price: {
            from: "dari"
        },
        orderScreen: {
            title: "Buat Pesanan",
            buttons: {
                placeOrder: 'Buat Pesanan'
            },
            deliveryType: {
                label: "Bagaimana anda ingin menerima pesanan?",
                onsite: "Di restoran",
                delivery: "Penghantaran ke alamat",
                pickup: "Ambil sendiri"
            },
            fields: {
                deliveryRegion: "Wilayah penghantaran",
                pickupPoint: "Titik pengambilan",
                name: "Nama",
                phone: "Telefon",
                address: "Alamat penghantaran",
                comment: "Komen pesanan"
            },
            placeholders: {
                deliveryRegion: "Ke wilayah mana untuk dihantar?",
                name: "Apa yang harus kami panggil anda?",
                phone: "+60 00 000 0000",
                address: "Ke mana untuk dihantar?",
                comment: "Komen pesanan"
            },
            errors: {
                deliveryRegion: "* Sila pilih wilayah penghantaran",
                name: "* Sila masukkan nama anda",
                phone: {
                    empty: "* Berikan nombor telefon hubungan",
                    invalid: "* Nombor telefon nampaknya salah. Mesti mempunyai sekurang-kurangnya 5 digit"
                },
                address: "* Sila berikan alamat penghantaran",
                comment: "* Sila tambah komen pada pesanan anda",
                pickupPoint: "* Sila nyatakan di mana anda ingin mengambil pesanan",
                required: "* Medan wajib"
            },
            deliveryInfo: {
                cost: "Kos penghantaran ke wilayah ini adalah"
            },
            agreement: {
                text: "Dengan meneruskan, anda bersetuju dengan pemprosesan data peribadi dan bersetuju dengan",
                userAgreement: "Perjanjian Pengguna",
                and: "dan",
                privacyPolicy: "Dasar Privasi"
            }
        },
        modSelector: {
            outOfStock: "tiada stok"
        },
        variantSelector: {
            chooseOption: 'Pilih pilihan'
        },
        notifications: {
            productStopped: 'Sementara tidak tersedia',
            maxQuantityExceeded: 'Terdapat had {max} item setiap pesanan untuk produk ini'
        }
    },
    zh: {
        common: {
            unknownError: '未知错误'
        },
        actions: {
            button: '呼叫服务员',
            popupTitle: '呼叫服务员',
            popupSubmitButton: '发送',
            popupCloseButton: '关闭',
            notifSuccess: '请求已发送',
            notifFailed: '错误。请重试',
            notifError: '发生错误',
        },
        nav: {
            categories: '菜单分类',
            favorite: '收藏',
            search: '搜索',
            allergens: '过敏原',
        },
        buttons: {
            addToCart: '加入购物车'
        },
        search: {
            placeholder: "搜索...",
            nothingFound: "未找到任何结果"
        },
        order: {
            title: "下单",
            success: {
                title: "完成",
                message: "订单已成功提交。我们会尽快联系您",
                orderNumber: "您的订单号"
            },
            error: {
                title: "错误",
                placement: "下单时出错"
            },
            buttons: {
                return: '返回菜单',
                retry: '重试',
                save: '保存菜单到手机'
            }
        },
        cart: {
            all: "全部",
            title: "我的购物车",
            empty: "购物车为空",
            widget: "购物车中",
            itemsCount: "项",
            openMenu: "打开菜单",
            unnamed: "未命名",
            notInCart: "尚未加入购物车",
            askWaiter: "请向服务员下单",
            buttons: {
                retry: "重试",
                returnToMenu: "返回菜单",
                saveMenu: "保存菜单到手机"
            }
        },
        filters: {
            allergens: '过敏原'
        },
        blocks: {
            recommendations: {
                title: "推荐",
                empty: "暂无推荐"
            },
            favorites: {
                title: "您喜爱的菜品",
                empty: "暂无收藏的菜品"
            },
            total: {
                sum: "小计",
                delivery: "配送",
                deliveryCost: "配送费",
                total: "总计"
            }
        },
        footer: {
            address: "地址",
            contacts: "联系方式",
            map: "地图",
            privacyPolicy: "隐私政策",
            termsOfUse: "使用条款"
        },
        docs: {
            privacyPolicy: '隐私政策',
            accept: '我同意根据隐私政策和适用的数据保护法规处理我的个人数据。'
        },
        legal: {
            title: '法律信息'
        },
        cartOrder: {
            placeOrder: "下单",
            closed: "餐厅已关闭",
            minOrder: "最低订单",
            minOrderMessage: "您的订单金额低于最低要求。要下单，您需要在购物车中添加至少",
            deliveryClosedMessage: "很抱歉，配送服务目前关闭。我们将接受您的订单，并在服务开放后立即处理。",
            openInMinutes: "配送服务将在",
            minutes: "分钟后开放",
            openAt: "配送服务营业时间"
        },
        dmLabel: {
            text: "此菜单在平台上制作",
        },
        nutrition: {
            title: "营养成分",
            weight: "份量",
            perServing: "每份",
            addToFavorites: "加入收藏",
            inFavorites: "已收藏",
            calories: '卡路里',
            proteins: '蛋白质',
            fats: '脂肪',
            carbs: '碳水化合物',
            gram: '克'
        },
        allergens: {
            contains: '含有',
            Cereals: '谷物',
            Avocado: '牛油果',
            Peanuts: '花生',
            gluten: '麸质',
            Mustard: '芥末',
            "Sulphur dioxide": '二氧化硫',
            Sesame: '芝麻',
            Lupin: '羽扇豆',
            Molluscs: '软体动物',
            Milk: '牛奶',
            Nuts: '坚果',
            Crustaceans: '甲壳类',
            Fish: '鱼类',
            Celery: '芹菜',
            Soya: '大豆',
            Eggs: '鸡蛋'
        },
        addToCart: {
            add: "添加",
            added: "已添加"
        },
        details: {
            description: "描述",
            ingredients: "成分",
            weight: "重量",
            close: "关闭"
        },
        price: {
            from: "起"
        },
        orderScreen: {
            title: "下单",
            buttons: {
                placeOrder: '下单'
            },
            deliveryType: {
                label: "您希望如何接收订单？",
                onsite: "在餐厅",
                delivery: "配送到地址",
                pickup: "自取"
            },
            fields: {
                deliveryRegion: "配送区域",
                pickupPoint: "自取点",
                name: "姓名",
                phone: "电话",
                address: "配送地址",
                comment: "订单备注"
            },
            placeholders: {
                deliveryRegion: "配送到哪个区域？",
                name: "我们应该如何称呼您？",
                phone: "+86 000 0000 0000",
                address: "配送到哪里？",
                comment: "订单备注"
            },
            errors: {
                deliveryRegion: "* 请选择配送区域",
                name: "* 请输入您的姓名",
                phone: {
                    empty: "* 请提供联系电话",
                    invalid: "* 电话号码似乎不正确。至少需要5位数字"
                },
                address: "* 请提供配送地址",
                comment: "* 请为订单添加备注",
                pickupPoint: "* 请指定您想在哪里取餐",
                required: "* 必填字段"
            },
            deliveryInfo: {
                cost: "此区域的配送费用为"
            },
            agreement: {
                text: "继续即表示您同意处理个人数据并同意",
                userAgreement: "用户协议",
                and: "和",
                privacyPolicy: "隐私政策"
            }
        },
        modSelector: {
            outOfStock: "缺货"
        },
        variantSelector: {
            chooseOption: '选择选项'
        },
        notifications: {
            productStopped: '暂时不可用',
            maxQuantityExceeded: '此产品每个订单限制为 {max} 件'
        }
    },
    ja: {
        common: {
            unknownError: '不明なエラー'
        },
        actions: {
            button: 'スタッフを呼ぶ',
            popupTitle: 'スタッフを呼ぶ',
            popupSubmitButton: '送信',
            popupCloseButton: '閉じる',
            notifSuccess: 'リクエストを送信しました',
            notifFailed: 'エラー。もう一度お試しください',
            notifError: 'エラーが発生しました',
        },
        nav: {
            categories: 'メニューカテゴリー',
            favorite: 'お気に入り',
            search: '検索',
            allergens: 'アレルゲン',
        },
        buttons: {
            addToCart: 'カートに追加'
        },
        search: {
            placeholder: "検索...",
            nothingFound: "見つかりませんでした"
        },
        order: {
            title: "注文する",
            success: {
                title: "完了",
                message: "注文が正常に送信されました。すぐにご連絡いたします",
                orderNumber: "ご注文番号"
            },
            error: {
                title: "エラー",
                placement: "注文時のエラー"
            },
            buttons: {
                return: 'メニューに戻る',
                retry: '再試行',
                save: 'メニューを電話に保存'
            }
        },
        cart: {
            all: "すべて",
            title: "マイカート",
            empty: "カートは空です",
            widget: "カート内",
            itemsCount: "点",
            openMenu: "メニューを開く",
            unnamed: "名前なし",
            notInCart: "まだカートに追加されていません",
            askWaiter: "注文するにはウェイターにお声がけください",
            buttons: {
                retry: "再試行",
                returnToMenu: "メニューに戻る",
                saveMenu: "メニューを電話に保存"
            }
        },
        filters: {
            allergens: 'アレルゲン'
        },
        blocks: {
            recommendations: {
                title: "おすすめ",
                empty: "おすすめはありません"
            },
            favorites: {
                title: "お気に入りの料理",
                empty: "お気に入りの料理はありません"
            },
            total: {
                sum: "小計",
                delivery: "配達",
                deliveryCost: "配達料",
                total: "合計"
            }
        },
        footer: {
            address: "住所",
            contacts: "連絡先",
            map: "地図",
            privacyPolicy: "プライバシーポリシー",
            termsOfUse: "利用規約"
        },
        docs: {
            privacyPolicy: 'プライバシーポリシー',
            accept: 'プライバシーポリシーおよび適用されるデータ保護法に従って、個人データの処理に同意します。'
        },
        legal: {
            title: '法的情報'
        },
        cartOrder: {
            placeOrder: "注文する",
            closed: "レストランは閉店しています",
            minOrder: "最低注文額",
            minOrderMessage: "ご注文金額が最低額を下回っています。注文するには、カートに少なくとも",
            deliveryClosedMessage: "申し訳ございませんが、配達サービスは現在閉店しています。ご注文を受け付け、サービスが開始次第すぐに処理いたします。",
            openInMinutes: "配達サービスは",
            minutes: "分後に開始",
            openAt: "配達サービスの営業時間"
        },
        dmLabel: {
            text: "このメニューはプラットフォームで作成されました",
        },
        nutrition: {
            title: "栄養情報",
            weight: "1人前のサイズ",
            perServing: "1人前あたり",
            addToFavorites: "お気に入りに追加",
            inFavorites: "お気に入りにあります",
            calories: 'カロリー',
            proteins: 'タンパク質',
            fats: '脂質',
            carbs: '炭水化物',
            gram: 'g'
        },
        allergens: {
            contains: '含む',
            Cereals: '穀物',
            Avocado: 'アボカド',
            Peanuts: 'ピーナッツ',
            gluten: 'グルテン',
            Mustard: 'マスタード',
            "Sulphur dioxide": '二酸化硫黄',
            Sesame: 'ごま',
            Lupin: 'ルピナス',
            Molluscs: '軟体動物',
            Milk: '牛乳',
            Nuts: 'ナッツ',
            Crustaceans: '甲殻類',
            Fish: '魚',
            Celery: 'セロリ',
            Soya: '大豆',
            Eggs: '卵'
        },
        addToCart: {
            add: "追加",
            added: "追加済み"
        },
        details: {
            description: "説明",
            ingredients: "材料",
            weight: "重量",
            close: "閉じる"
        },
        price: {
            from: "から"
        },
        orderScreen: {
            title: "注文する",
            buttons: {
                placeOrder: '注文する'
            },
            deliveryType: {
                label: "注文の受け取り方法を選択してください",
                onsite: "店内で",
                delivery: "住所に配達",
                pickup: "持ち帰り"
            },
            fields: {
                deliveryRegion: "配達エリア",
                pickupPoint: "受け取り場所",
                name: "お名前",
                phone: "電話番号",
                address: "配達先住所",
                comment: "注文メモ"
            },
            placeholders: {
                deliveryRegion: "どのエリアに配達しますか？",
                name: "お名前を教えてください",
                phone: "+81 00-0000-0000",
                address: "どこに配達しますか？",
                comment: "注文メモ"
            },
            errors: {
                deliveryRegion: "* 配達エリアを選択してください",
                name: "* お名前を入力してください",
                phone: {
                    empty: "* 連絡先電話番号を入力してください",
                    invalid: "* 電話番号が正しくないようです。少なくとも5桁の数字が必要です"
                },
                address: "* 配達先住所を入力してください",
                comment: "* 注文にメモを追加してください",
                pickupPoint: "* 受け取り場所を指定してください",
                required: "* 必須項目"
            },
            deliveryInfo: {
                cost: "このエリアへの配達料金は"
            },
            agreement: {
                text: "続行することで、個人データの処理に同意し、",
                userAgreement: "利用規約",
                and: "および",
                privacyPolicy: "プライバシーポリシー"
            }
        },
        modSelector: {
            outOfStock: "在庫切れ"
        },
        variantSelector: {
            chooseOption: 'オプションを選択'
        },
        notifications: {
            productStopped: '一時的に利用できません',
            maxQuantityExceeded: 'この商品は注文あたり {max} 個までに制限されています'
        }
    },
    pt: {
        common: {
            unknownError: 'Erro desconhecido'
        },
        actions: {
            button: 'Chamar funcionário',
            popupTitle: 'Chamar funcionário',
            popupSubmitButton: 'Enviar',
            popupCloseButton: 'Fechar',
            notifSuccess: 'Solicitação enviada',
            notifFailed: 'Erro. Por favor, tente novamente',
            notifError: 'Ocorreu um erro',
        },
        nav: {
            categories: 'Categorias do menu',
            favorite: 'Favoritos',
            search: 'Pesquisar',
            allergens: 'Alérgenos',
        },
        buttons: {
            addToCart: 'Adicionar ao Carrinho'
        },
        search: {
            placeholder: "Pesquisar...",
            nothingFound: "Nada encontrado"
        },
        order: {
            title: "Fazer Pedido",
            success: {
                title: "Concluído",
                message: "Pedido realizado com sucesso. Entraremos em contato em breve",
                orderNumber: "Número do seu pedido"
            },
            error: {
                title: "Erro",
                placement: "Erro ao fazer pedido"
            },
            buttons: {
                return: 'Voltar ao menu',
                retry: 'Tentar novamente',
                save: 'Salvar menu no telefone'
            }
        },
        cart: {
            all: "Todos",
            title: "Meu Carrinho",
            empty: "Carrinho vazio",
            widget: "No Carrinho",
            itemsCount: "item(ns)",
            openMenu: "Abrir Menu",
            unnamed: "Sem nome",
            notInCart: "ainda não adicionado ao carrinho",
            askWaiter: "Por favor, peça ao garçom para fazer o pedido",
            buttons: {
                retry: "Tentar Novamente",
                returnToMenu: "Voltar ao Menu",
                saveMenu: "Salvar Menu no Telefone"
            }
        },
        filters: {
            allergens: 'Alérgenos'
        },
        blocks: {
            recommendations: {
                title: "Recomendados",
                empty: "Sem recomendações"
            },
            favorites: {
                title: "Seus Pratos Favoritos",
                empty: "Sem pratos favoritos"
            },
            total: {
                sum: "Subtotal",
                delivery: "Entrega",
                deliveryCost: "Custo de entrega",
                total: "Total"
            }
        },
        footer: {
            address: "Endereço",
            contacts: "Contatos",
            map: "Mapa",
            privacyPolicy: "Política de Privacidade",
            termsOfUse: "Termos de Uso"
        },
        docs: {
            privacyPolicy: 'Política de Privacidade',
            accept: 'Consinto com o processamento dos meus dados pessoais de acordo com a Política de Privacidade e a legislação aplicável de proteção de dados.'
        },
        legal: {
            title: 'Informações legais'
        },
        cartOrder: {
            placeOrder: "Fazer Pedido",
            closed: "Restaurante fechado",
            minOrder: "Pedido mínimo",
            minOrderMessage: "O valor do seu pedido está abaixo do mínimo. Para fazer um pedido, você precisa adicionar itens no valor de pelo menos",
            deliveryClosedMessage: "Infelizmente, o serviço de entrega está fechado no momento. Aceitaremos seu pedido e o processaremos assim que o serviço abrir.",
            openInMinutes: "A entrega abrirá em",
            minutes: "min.",
            openAt: "O serviço de entrega funciona das"
        },
        dmLabel: {
            text: "Este menu foi criado na plataforma",
        },
        nutrition: {
            title: "Informação Nutricional",
            weight: "Tamanho da porção",
            perServing: "por porção",
            addToFavorites: "Adicionar aos favoritos",
            inFavorites: "Nos favoritos",
            calories: 'kcal',
            proteins: 'proteínas',
            fats: 'gorduras',
            carbs: 'carboidratos',
            gram: 'g'
        },
        allergens: {
            contains: 'Contém',
            Cereals: 'Cereais',
            Avocado: 'Abacate',
            Peanuts: 'Amendoim',
            gluten: 'Glúten',
            Mustard: 'Mostarda',
            "Sulphur dioxide": 'Dióxido de enxofre',
            Sesame: 'Gergelim',
            Lupin: 'Tremoço',
            Molluscs: 'Moluscos',
            Milk: 'Leite',
            Nuts: 'Nozes',
            Crustaceans: 'Crustáceos',
            Fish: 'Peixe',
            Celery: 'Aipo',
            Soya: 'Soja',
            Eggs: 'Ovos'
        },
        addToCart: {
            add: "Adicionar",
            added: "Adicionado"
        },
        details: {
            description: "Descrição",
            ingredients: "Ingredientes",
            weight: "Peso",
            close: "Fechar"
        },
        price: {
            from: "a partir de"
        },
        orderScreen: {
            title: "Fazer Pedido",
            buttons: {
                placeOrder: 'Fazer Pedido'
            },
            deliveryType: {
                label: "Como você gostaria de receber seu pedido?",
                onsite: "No restaurante",
                delivery: "Entrega no endereço",
                pickup: "Retirada"
            },
            fields: {
                deliveryRegion: "Área de entrega",
                pickupPoint: "Ponto de retirada",
                name: "Nome",
                phone: "Telefone",
                address: "Endereço de entrega",
                comment: "Comentário do pedido"
            },
            placeholders: {
                deliveryRegion: "Para qual área entregar?",
                name: "Como devemos chamá-lo?",
                phone: "+55 00 00000-0000",
                address: "Onde entregar?",
                comment: "Comentário do pedido"
            },
            errors: {
                deliveryRegion: "* Por favor, selecione uma área de entrega",
                name: "* Por favor, insira seu nome",
                phone: {
                    empty: "* Forneça um telefone para contato",
                    invalid: "* O número de telefone parece incorreto. Deve ter pelo menos 5 dígitos"
                },
                address: "* Por favor, forneça o endereço de entrega",
                comment: "* Por favor, adicione um comentário ao seu pedido",
                pickupPoint: "* Por favor, especifique onde você gostaria de retirar seu pedido",
                required: "* Campo obrigatório"
            },
            deliveryInfo: {
                cost: "O custo de entrega para esta área será"
            },
            agreement: {
                text: "Ao continuar, você consente com o processamento de dados pessoais e concorda com o",
                userAgreement: "Acordo do Usuário",
                and: "e",
                privacyPolicy: "Política de Privacidade"
            }
        },
        modSelector: {
            outOfStock: "sem estoque"
        },
        variantSelector: {
            chooseOption: 'Escolha uma opção'
        },
        notifications: {
            productStopped: 'Temporariamente indisponível',
            maxQuantityExceeded: 'Há um limite de {max} itens por pedido para este produto'
        }
    }
};
